export const vision = '5.7.0';

export const db = {
  artifacts: {
    art1: {
      icon: '59.png',
      type: 'damage',
      inactive_adj: 0,
      name: '暗影之书',
      id: 'Artifact22',
      enchant: true,
      max: 0,
      effect: 0.05,
      gmax: 0.12,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 2.5,
      tcoef: 0.2,
      texpo: 3.5,
      gpeak: 1.0862780491200215,
      adcalc: 0.000062,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'BoS',
    },
    art95: {
      icon: '91.png',
      type: 'gold',
      inactive_adj: 0,
      name: '复仇誓言',
      id: 'Artifact95',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.18,
      grate: 0.0001,
      gexpo: 1.35,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.8,
      tcoef: 0.2143,
      texpo: 2.8,
      gpeak: 1,
      adcalc: 0.000172,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0.8,
        chest: 0.8,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CC',
    },
    art2: {
      icon: '74.png',
      type: 'gold',
      inactive_adj: 0,
      name: '瓦如恩之石',
      id: 'Artifact2',
      enchant: true,
      max: 0,
      effect: 0.01,
      gmax: 0.36,
      grate: 0.00018,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.8,
      tcoef: 0.2143,
      texpo: 2.8,
      gpeak: 1.1349008767288886,
      adcalc: 0.000172,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 3.2,
        fairy: 3.2,
        chest: 3.2,
        boss: 3.2,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SotV',
    },
    art3: {
      icon: '77.png',
      type: 'gold',
      inactive_adj: 0,
      name: '满足宝箱',
      id: 'Artifact19',
      enchant: true,
      max: 0,
      effect: 0.25,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.4,
      ccoef: 1,
      cexpo: 1.8,
      tcoef: 0.3571,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.007989,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0.8,
        chest: 0.8,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CoC',
    },
    art4: {
      icon: '84.png',
      type: 'gold',
      inactive_adj: 0,
      name: '英勇之盾',
      id: 'Artifact1',
      enchant: true,
      max: 0,
      effect: 0.25,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.4,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.002943,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0,
        chest: 0,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HSh',
    },
    art5: {
      icon: '52.png',
      type: 'gold',
      inactive_adj: 0,
      name: '预言之书',
      id: 'Artifact20',
      enchant: true,
      max: 0,
      effect: 0.25,
      gmax: 0.4,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.216552506059644,
      adcalc: 0.000215,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0.8,
        chest: 0.8,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'BoP',
    },
    art6: {
      icon: '35.png',
      type: 'gold',
      inactive_adj: 0.8,
      name: '点金之碗',
      id: 'Artifact66',
      max: 0,
      effect: 0.04,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.001083,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 1.6,
        fairy: 1.6,
        chest: 1.6,
        boss: 1.6,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'KB',
    },
    art7: {
      icon: '42.png',
      type: 'gold',
      inactive_adj: 0.8,
      name: '扎金索斯银币',
      id: 'Artifact43',
      max: 0,
      effect: 0.6,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.001083,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0.8,
        chest: 0.8,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'ZC',
    },
    art8: {
      icon: '43.png',
      type: 'gold',
      inactive_adj: 0,
      name: '崇高仙子徽章',
      id: 'Artifact44',
      enchant: true,
      max: 0,
      effect: 0.3,
      gmax: 0.4,
      grate: 0.00018,
      gexpo: 0.5,
      ad: 0.4,
      ccoef: 1,
      cexpo: 1.8,
      tcoef: 0.35714,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.007989,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0.8,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'GFM',
    },
    art9: {
      icon: '44.png',
      type: 'gold',
      inactive_adj: 0,
      name: '招财猫像',
      id: 'Artifact45',
      enchant: true,
      max: 0,
      effect: 0.3,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.00639,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'NS',
    },
    art10: {
      icon: '17.png',
      type: 'gold',
      inactive_adj: 0,
      name: '财神金币',
      id: 'Artifact79',
      enchant: true,
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.001083,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0.8,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CoE',
    },
    art11: {
      icon: '28.png',
      type: 'gold',
      inactive_adj: 0,
      name: '金币罗盘',
      id: 'Artifact82',
      enchant: true,
      max: 0,
      effect: 0.04,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.120714058089752,
      adcalc: 0.001083,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0.8,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TBC',
    },
    art94: {
      icon: '92.png',
      type: 'damage',
      inactive_adj: 0,
      name: '历战牌堆',
      id: 'Artifact94',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 1.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 2.2,
      tcoef: 0.1875,
      texpo: 3.2,
      gpeak: 1,
      adcalc: 0.000026,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'ES',
    },
    art12: {
      icon: '03.png',
      type: 'damage',
      inactive_adj: 0,
      name: '独奏长笛',
      id: 'Artifact84',
      enchant: true,
      max: 0,
      effect: 0.01,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 2.2,
      tcoef: 0.1875,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.000026,
      reductions_orig: {
        cs: 4,
        sc: 4,
        pet: 4,
        hs: 4,
        hscs: 4,
        hssc: 4,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FotS',
    },
    art13: {
      icon: '73.png',
      type: 'damage',
      inactive_adj: 0,
      name: '天堂之剑',
      id: 'Artifact26',
      enchant: true,
      max: 0,
      effect: 0.05,
      gmax: 0.4,
      grate: 0.00025,
      gexpo: 0.5,
      ad: 1,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.216552506059644,
      adcalc: 0.025619,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HSw',
    },
    art14: {
      icon: '89.png',
      type: 'damage',
      inactive_adj: 0,
      name: '神圣报应',
      id: 'Artifact31',
      enchant: true,
      max: 0,
      effect: 0.1,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 1,
      ccoef: 1,
      cexpo: 2,
      tcoef: 0.3333,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.125,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'DR',
    },
    art15: {
      icon: '72.png',
      type: 'damage',
      inactive_adj: 0,
      name: '醉汉榔头',
      id: 'Artifact29',
      enchant: true,
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001064,
      reductions_orig: {
        cs: 0,
        sc: 0.6,
        pet: 1,
        hs: 1,
        hscs: 0.6,
        hssc: 0.76,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'DH',
    },
    art16: {
      icon: '37.png',
      type: 'damage',
      inactive_adj: 0,
      name: '萨摩赛克之剑',
      id: 'Artifact51',
      max: 0,
      effect: 0.2,
      gmax: 0.32,
      grate: 0.00014,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2,
      tcoef: 0.2333,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.003247,
      reductions_orig: {
        cs: 0,
        sc: 0.6,
        pet: 0,
        hs: 0.8,
        hscs: 0.48,
        hssc: 0.68,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SS',
    },
    art17: {
      icon: '11.png',
      type: 'damage',
      inactive_adj: 0,
      name: '复仇者',
      id: 'Artifact59',
      enchant: true,
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'Ret',
    },
    art18: {
      icon: '06.png',
      type: 'damage',
      inactive_adj: 0,
      name: '宁静之剑',
      id: 'Artifact83',
      max: 0,
      effect: 0.04,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 1,
      ccoef: 1,
      cexpo: 2,
      tcoef: 0.3333,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.125,
      reductions_orig: {
        cs: 1,
        sc: 1.2,
        pet: 1.5,
        hs: 1.5,
        hscs: 1.3,
        hssc: 1.32,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SP',
    },
    art19: {
      icon: '79.png',
      type: 'damage',
      inactive_adj: 0,
      name: '英雄之刃',
      id: 'Artifact35',
      max: 0,
      effect: 0.15,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.008931,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HB',
    },
    art20: {
      icon: '80.png',
      type: 'hero',
      inactive_adj: 0,
      name: '风暴之剑',
      id: 'Artifact32',
      enchant: true,
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001613,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TSS',
    },
    art21: {
      icon: '86.png',
      type: 'hero',
      inactive_adj: 0,
      name: '复仇女神之弓',
      id: 'Artifact33',
      enchant: true,
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001613,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FB',
    },
    art22: {
      icon: '75.png',
      type: 'hero',
      inactive_adj: 0,
      name: '古代护身符',
      id: 'Artifact34',
      enchant: true,
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001613,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CotA',
    },
    art23: {
      icon: '04.png',
      type: 'hero',
      inactive_adj: 0,
      name: '泰坦树苗',
      id: 'Artifact61',
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001613,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TTT',
    },
    art24: {
      icon: '31.png',
      type: 'hero',
      inactive_adj: 0,
      name: '飞毛头盔',
      id: 'Artifact62',
      max: 0,
      effect: 0.2,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001613,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HoH',
    },
    art25: {
      icon: '49.png',
      type: 'damage',
      inactive_adj: 0,
      name: '伊甸之果',
      id: 'Artifact38',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2,
      tcoef: 0.2333,
      texpo: 3,
      gpeak: 1.1832159566199232,
      adcalc: 0.003247,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 1,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FoE',
    },
    art26: {
      icon: '87.png',
      type: 'damage',
      inactive_adj: 0,
      name: '感化灵药',
      id: 'Artifact30',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 1.7,
      tcoef: 0.2593,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.008931,
      reductions_orig: {
        cs: 1,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0.4,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'IE',
    },
    art27: {
      icon: '30.png',
      type: 'damage',
      inactive_adj: 0,
      name: '星辰吊链',
      id: 'Artifact64',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 1.8,
      tcoef: 0.25,
      texpo: 2.8,
      gpeak: 1.1489125293076057,
      adcalc: 0.00639,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 0,
        hscs: 0.4,
        hssc: 0.6,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'ORC',
    },
    art28: {
      icon: '40.png',
      type: 'damage',
      inactive_adj: 0,
      name: '风暴之心',
      id: 'Artifact52',
      max: 0,
      effect: 0.005,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 6,
        sc: 5.6,
        pet: 6,
        hs: 6,
        hscs: 6,
        hssc: 5.76,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HoS',
    },
    art29: {
      icon: '38.png',
      type: 'gold',
      inactive_adj: 0,
      name: '太阳神之石',
      id: 'Artifact53',
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 1.6,
        fairy: 1.6,
        chest: 1.6,
        boss: 1.6,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AO',
    },
    art96: {
      icon: '96.png',
      type: 'damage',
      inactive_adj: 0,
      name: '黏黏果实',
      id: 'Artifact96',
      max: 0,
      effect: 0.005,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2,
      texpo: 3.2,
      gpeak: 0.8,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 2,
        sc: 1.6,
        pet: 1.5,
        hs: 1.5,
        hscs: 1.75,
        hssc: 1.55,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SF',
    },
    art97: {
      icon: '97.png',
      type: 'gold',
      inactive_adj: 0,
      name: '冥王宝珠',
      id: 'Artifact97',
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2,
      texpo: 3.2,
      gpeak: 1.1,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 1,
        fairy: 1,
        chest: 1,
        boss: 1,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HO',
    },
    art30: {
      icon: '33.png',
      type: 'damage',
      inactive_adj: 0,
      name: '圣殿耳环',
      id: 'Artifact67',
      enchant: true,
      max: 0,
      effect: 0.03,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001064,
      reductions_orig: {
        cs: 2,
        sc: 2,
        pet: 2,
        hs: 2,
        hscs: 2,
        hssc: 2,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'EoP',
    },
    art31: {
      icon: '55.png',
      type: 'damage',
      inactive_adj: 0,
      name: '仙鸟之羽',
      id: 'Artifact42',
      enchant: true,
      max: 0,
      effect: 0.5,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001064,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 2,
        hscs: 2,
        hssc: 2,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AF',
    },
    art32: {
      icon: '45.png',
      type: 'damage',
      inactive_adj: 0,
      name: '腐败符文之心',
      id: 'Artifact46',
      max: 0,
      effect: 0.00025,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.3,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.001064,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CRH',
    },
    art33: {
      icon: '15.png',
      type: 'damage',
      inactive_adj: 0,
      name: '迪朗达尔之剑',
      id: 'Artifact55',
      enchant: true,
      max: 0,
      effect: 0.24,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 1,
      ccoef: 1,
      cexpo: 2,
      tcoef: 0.3333,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.125,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'DSw',
    },
    art34: {
      icon: '29.png',
      type: 'damage',
      inactive_adj: 0,
      name: '冥界头骨',
      id: 'Artifact56',
      enchant: true,
      max: 0,
      effect: 0.12,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 1,
      ccoef: 1,
      cexpo: 2,
      tcoef: 0.3333,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.125,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HSk',
    },
    art35: {
      icon: '26.png',
      type: 'damage',
      inactive_adj: 0,
      name: '永守誓言',
      id: 'Artifact75',
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2.2,
      tcoef: 0.2031,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001289,
      reductions_orig: {
        cs: 0,
        sc: 1.2,
        pet: 3,
        hs: 2,
        hscs: 1.2,
        hssc: 1.52,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'OB',
    },
    art36: {
      icon: '25.png',
      type: 'damage',
      inactive_adj: 0,
      name: '群星王冠',
      id: 'Artifact76',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2.2,
      tcoef: 0.2031,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001289,
      reductions_orig: {
        cs: 3,
        sc: 1.2,
        pet: 1,
        hs: 1,
        hscs: 1.8,
        hssc: 1.12,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'CotC',
    },
    art37: {
      icon: '27.png',
      type: 'damage',
      inactive_adj: 0,
      name: '仙后法杖',
      id: 'Artifact77',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2.2,
      tcoef: 0.2031,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001289,
      reductions_orig: {
        cs: 0.8,
        sc: 1.8,
        pet: 0.8,
        hs: 1.8,
        hscs: 1.4,
        hssc: 1.8,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TSc',
    },
    art38: {
      icon: '24.png',
      type: 'damage',
      inactive_adj: 1.8,
      name: '蛊惑手套',
      id: 'Artifact78',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2.2,
      tcoef: 0.2031,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001289,
      reductions_orig: {
        cs: 2.3,
        sc: 2.4,
        pet: 2.4,
        hs: 2.4,
        hscs: 2.36,
        hssc: 2.4,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FG',
    },
    art39: {
      icon: '53.png',
      type: 'damage',
      inactive_adj: 0,
      name: '卡利斯托之戒',
      id: 'Artifact40',
      enchant: true,
      max: 0,
      effect: 0.01,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2.2,
      tcoef: 0.2031,
      texpo: 3.2,
      gpeak: 1.1764352935882194,
      adcalc: 0.001289,
      reductions_orig: {
        cs: 4.8,
        sc: 4.4,
        pet: 4.3,
        hs: 3.6,
        hscs: 4.08,
        hssc: 4.08,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'RoC',
    },
    art40: {
      icon: '81.png',
      type: 'damage',
      inactive_adj: 0,
      name: '达摩克利斯之剑',
      id: 'Artifact25',
      max: 0,
      effect: 0.08,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2,
      tcoef: 0.2167,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.0026,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'BoD',
    },
    art41: {
      icon: '51.png',
      type: 'damage',
      inactive_adj: 0,
      name: '疯狂头盔',
      id: 'Artifact17',
      max: 0,
      effect: 0.08,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2,
      tcoef: 0.2167,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.0026,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.8,
        hscs: 0.88,
        hssc: 0.68,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HoM',
    },
    art42: {
      icon: '66.png',
      type: 'gold',
      inactive_adj: 0,
      name: '钛钢镀饰',
      id: 'Artifact23',
      max: 0,
      effect: 0.08,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2,
      tcoef: 0.2167,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.0026,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.8,
        fairy: 0.8,
        chest: 0.8,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TP',
    },
    art43: {
      icon: '08.png',
      type: 'damage',
      inactive_adj: 0,
      name: '月光手镯',
      id: 'Artifact73',
      enchant: true,
      max: 0,
      effect: 0.08,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2,
      tcoef: 0.2167,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.0026,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MB',
    },
    art44: {
      icon: '82.png',
      type: 'damage',
      inactive_adj: 0,
      name: '紫晶之杖',
      id: 'Artifact28',
      max: 0,
      effect: 0.08,
      gmax: 0.32,
      grate: 0.00015,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.65,
      cexpo: 2,
      tcoef: 0.2167,
      texpo: 3,
      gpeak: 1.1489125293076057,
      adcalc: 0.0026,
      reductions_orig: {
        cs: 1,
        sc: 1,
        pet: 1,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AS',
    },
    art45: {
      icon: '20.png',
      type: 'hero',
      inactive_adj: 0,
      name: '皇家圣剑',
      id: 'Artifact86',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 2,
        sc: 1.6,
        pet: 1.5,
        hs: 1.5,
        hscs: 1.7,
        hssc: 1.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SotR',
    },
    art46: {
      icon: '19.png',
      type: 'hero',
      inactive_adj: 0,
      name: '精神守夜者',
      id: 'Artifact87',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 2,
        sc: 1.2,
        pet: 1,
        hs: 1.3,
        hscs: 1.58,
        hssc: 1.2400000000000002,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SV',
    },
    art47: {
      icon: '21.png',
      type: 'hero',
      inactive_adj: 0,
      name: '钴蓝铠甲',
      id: 'Artifact88',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 1.8,
        sc: 1.4,
        pet: 1.3,
        hs: 1.3,
        hscs: 1.5,
        hssc: 1.36,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TCP',
    },
    art48: {
      icon: '14.png',
      type: 'hero',
      inactive_adj: 0,
      name: '审判印记',
      id: 'Artifact89',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 2,
        sc: 1.6,
        pet: 1.5,
        hs: 1.5,
        hscs: 1.7,
        hssc: 1.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SoJ',
    },
    art49: {
      icon: '10.png',
      type: 'hero',
      inactive_adj: 0,
      name: '守护者的叶子',
      id: 'Artifact90',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.24,
      grate: 0.0001,
      gexpo: 0.5,
      ad: 0.5,
      ccoef: 0.7,
      cexpo: 2.2,
      tcoef: 0.2188,
      texpo: 3.2,
      gpeak: 1.1349008767288886,
      adcalc: 0.001633,
      reductions_orig: {
        cs: 2,
        sc: 1.6,
        pet: 1.5,
        hs: 1.5,
        hscs: 1.7,
        hssc: 1.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FotK',
    },
    art50: {
      icon: '46.png',
      type: 'damage',
      inactive_adj: 0,
      name: '入侵者的海姆达尔之角',
      id: 'Artifact47',
      enchant: true,
      max: 0,
      effect: 0.02,
      gmax: 0.36,
      grate: 0.00018,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.8,
      tcoef: 0.2143,
      texpo: 2.8,
      gpeak: 1.1349008767288886,
      adcalc: 0.000172,
      reductions_orig: {
        cs: 2.3,
        sc: 3.6,
        pet: 2.9,
        hs: 3.9,
        hscs: 3.26,
        hssc: 3.72,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'IG',
    },
    art51: {
      icon: '63.png',
      type: 'damage',
      inactive_adj: 0,
      name: '巨人面具',
      id: 'Artifact11',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 1,
        hscs: 1,
        hssc: 1,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TM',
    },
    art52: {
      icon: '54.png',
      type: 'damage',
      inactive_adj: 0,
      name: '皇室毒物',
      id: 'Artifact41',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 0.5,
        sc: 0.6,
        pet: 0.6,
        hs: 0,
        hscs: 0.56,
        hssc: 0.6,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'RT',
    },
    art53: {
      icon: '90.png',
      type: 'gold',
      inactive_adj: 0,
      name: '工人垂饰',
      id: 'Artifact9',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0.48,
        fairy: 0.48,
        chest: 0.8,
        boss: 0.8,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'LP',
    },
    art54: {
      icon: '56.png',
      type: 'damage',
      inactive_adj: 0,
      name: '诸神黄昏使者',
      id: 'Artifact10',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 0,
        sc: 0.6,
        pet: 1,
        hs: 1,
        hscs: 0.6,
        hssc: 0.76,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'BoR',
    },
    art55: {
      icon: '68.png',
      type: 'damage',
      inactive_adj: 0,
      name: '预知羊皮纸',
      id: 'Artifact7',
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 1,
        sc: 0.6,
        pet: 0.5,
        hs: 0.5,
        hscs: 0.7,
        hssc: 0.56,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'PoF',
    },
    art56: {
      icon: '60.png',
      type: 'damage',
      inactive_adj: 0,
      name: '伊甸灵丹',
      id: 'Artifact6',
      enchant: true,
      max: 0,
      effect: 0.1,
      gmax: 0.4,
      grate: 0.0002,
      gexpo: 0.5,
      ad: 0.2,
      ccoef: 0.6,
      cexpo: 1.7,
      tcoef: 0.2222,
      texpo: 2.7,
      gpeak: 1.131370849898476,
      adcalc: 0.000273,
      reductions_orig: {
        cs: 0,
        sc: 1,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0.6,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'EoE',
    },
    art57: {
      icon: '01.png',
      type: 'damage',
      inactive_adj: 0,
      name: '急躁沙漏',
      id: 'Artifact65',
      max: 40,
      effect: 0.02,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.000976,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HotI',
    },
    art58: {
      icon: '47.png',
      type: 'damage',
      inactive_adj: 0,
      name: '幻影时钟',
      id: 'Artifact48',
      max: 30,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 1,
      cexpo: 3,
      tcoef: 0.25,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.004078,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'PT',
    },
    art59: {
      icon: '85.png',
      type: 'damage',
      inactive_adj: 0,
      name: '禁忌卷轴',
      id: 'Artifact13',
      max: 30,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.5,
      ccoef: 0.6,
      cexpo: 2.4,
      tcoef: 0.1765,
      texpo: 3.4,
      gpeak: 1,
      adcalc: 0.049659,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'FS',
    },
    art60: {
      icon: '58.png',
      type: 'damage',
      inactive_adj: 0,
      name: '效忠指环',
      id: 'Artifact15',
      max: 30,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.5,
      ccoef: 0.6,
      cexpo: 2.4,
      tcoef: 0.1765,
      texpo: 3.4,
      gpeak: 1,
      adcalc: 0.049659,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'RoF',
    },
    art61: {
      icon: '70.png',
      type: 'damage',
      inactive_adj: 0,
      name: '冰川之斧',
      id: 'Artifact16',
      max: 30,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.5,
      ccoef: 0.6,
      cexpo: 2.4,
      tcoef: 0.1765,
      texpo: 3.4,
      gpeak: 1,
      adcalc: 0.049659,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'GA',
    },
    art62: {
      icon: '88.png',
      type: 'damage',
      inactive_adj: 0,
      name: '神盾',
      id: 'Artifact14',
      max: 30,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.5,
      ccoef: 0.6,
      cexpo: 2.4,
      tcoef: 0.1765,
      texpo: 3.4,
      gpeak: 1,
      adcalc: 0.049659,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'Aeg',
    },
    art63: {
      icon: '50.png',
      type: 'damage',
      inactive_adj: 0,
      name: '沼泽手套',
      id: 'Artifact12',
      max: 30,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.5,
      ccoef: 0.6,
      cexpo: 2.4,
      tcoef: 0.1765,
      texpo: 3.4,
      gpeak: 1,
      adcalc: 0.049659,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SG',
    },
    art64: {
      icon: '67.png',
      type: 'damage',
      inactive_adj: 0,
      name: '无限摆锤',
      id: 'Artifact36',
      max: 20,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.9,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000948,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'InfP',
    },
    art65: {
      icon: '76.png',
      type: 'damage',
      inactive_adj: 0,
      name: '大熊手套',
      id: 'Artifact27',
      max: 30,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'GoK',
    },
    art66: {
      icon: '78.png',
      type: 'damage',
      inactive_adj: 0,
      name: '巨人之矛',
      id: 'Artifact39',
      max: 40,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TSp',
    },
    art67: {
      icon: '71.png',
      type: 'damage',
      inactive_adj: 0,
      name: '橡木杖',
      id: 'Artifact37',
      max: 30,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'OS',
    },
    art68: {
      icon: '83.png',
      type: 'damage',
      inactive_adj: 0,
      name: '奥秘斗篷',
      id: 'Artifact3',
      max: 40,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TAC',
    },
    art69: {
      icon: '64.png',
      type: 'damage',
      inactive_adj: 0,
      name: '猎人药膏',
      id: 'Artifact8',
      max: 40,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'HO',
    },
    art70: {
      icon: '36.png',
      type: 'damage',
      inactive_adj: 0,
      name: '仙馔密酒',
      id: 'Artifact50',
      max: 40,
      effect: 2,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.6,
      cexpo: 3,
      tcoef: 0.15,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000529,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AE',
    },
    art71: {
      icon: '07.png',
      type: 'damage',
      inactive_adj: 0,
      name: '神秘权杖',
      id: 'Artifact58',
      max: 40,
      effect: 0.075,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MSt',
    },
    art72: {
      icon: '34.png',
      type: 'damage',
      inactive_adj: 0,
      name: '仙人魔豆',
      id: 'Artifact68',
      max: 40,
      effect: 0.0025,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MBoS',
    },
    art73: {
      icon: '57.png',
      type: 'damage',
      inactive_adj: 0,
      name: '幸运之卵',
      id: 'Artifact18',
      max: 40,
      effect: 0.005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 1.4,
      cexpo: 3,
      tcoef: 0.35,
      texpo: 4,
      gpeak: 1,
      adcalc: 1.480267,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'EoF',
    },
    art74: {
      icon: '69.png',
      type: 'damage',
      inactive_adj: 0,
      name: '圣杯',
      id: 'Artifact21',
      max: 50,
      effect: 0.01,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1,
      ccoef: 0.8,
      cexpo: 2.6,
      tcoef: 0.22224,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.014362,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'DC',
    },
    art75: {
      icon: '61.png',
      type: 'damage',
      inactive_adj: 0,
      name: '入侵者之盾',
      id: 'Artifact5',
      max: 50,
      effect: 0.005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 1.6,
      ccoef: 0.5,
      cexpo: 2.1,
      tcoef: 0.1613,
      texpo: 3.1,
      gpeak: 1,
      adcalc: 0.071318,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'IS',
    },
    art76: {
      icon: '65.png',
      type: 'damage',
      inactive_adj: 0,
      name: '死亡之斧',
      id: 'Artifact4',
      max: 40,
      effect: 0.005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 0.8,
      cexpo: 2.5,
      tcoef: 0.2286,
      texpo: 3.5,
      gpeak: 1,
      adcalc: 2.189783,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AoM',
    },
    art77: {
      icon: '39.png',
      type: 'damage',
      inactive_adj: 0,
      name: '狐仙精华',
      id: 'Artifact54',
      max: 40,
      effect: 0.005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 0.8,
      cexpo: 2.5,
      tcoef: 0.2286,
      texpo: 3.5,
      gpeak: 1,
      adcalc: 2.189783,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'EotK',
    },
    art78: {
      icon: '23.png',
      type: 'damage',
      inactive_adj: 0,
      name: '飞毛靴子',
      id: 'Artifact70',
      max: 40,
      effect: 0.001,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 0.8,
      cexpo: 2.5,
      tcoef: 0.2286,
      texpo: 3.5,
      gpeak: 1,
      adcalc: 2.189783,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'BoH',
    },
    art79: {
      icon: '02.png',
      type: 'damage',
      inactive_adj: 0,
      name: '释能护手',
      id: 'Artifact74',
      max: 40,
      effect: 0.0005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 0.8,
      cexpo: 2.5,
      tcoef: 0.2286,
      texpo: 3.5,
      gpeak: 1,
      adcalc: 2.189783,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'UG',
    },
    art80: {
      icon: '05.png',
      type: 'damage',
      inactive_adj: 0,
      name: '仙王项链',
      id: 'Artifact72',
      max: 40,
      effect: 0.002,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 0.8,
      cexpo: 2.5,
      tcoef: 0.2286,
      texpo: 3.5,
      gpeak: 1,
      adcalc: 2.189783,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'OP',
    },
    art81: {
      icon: '16.png',
      type: 'damage',
      inactive_adj: 0,
      name: '幸运兔脚',
      id: 'Artifact69',
      max: 40,
      effect: 0.0025,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'LFA',
    },
    art82: {
      icon: '32.png',
      type: 'damage',
      inactive_adj: 0,
      name: '王君面具',
      id: 'Artifact63',
      max: 40,
      effect: 0.02,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 3,
      tcoef: 0.125,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000255,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'LKM',
    },
    art83: {
      icon: '62.png',
      type: 'damage',
      inactive_adj: 0,
      name: '光辉之杖',
      id: 'Artifact24',
      max: 40,
      effect: 0.02,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.000976,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'SoR',
    },
    art84: {
      icon: '12.png',
      type: 'damage',
      inactive_adj: 0,
      name: '重剑无锋',
      id: 'Artifact71',
      max: 50,
      effect: 0.01,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 3,
      tcoef: 0.125,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000255,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MSw',
    },
    art91: {
      icon: '93.png',
      type: 'damage',
      inactive_adj: 0,
      name: '响石',
      id: 'Artifact91',
      max: 50,
      effect: 0.01,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 3,
      tcoef: 0.125,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000255,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MSw',
    },
    art92: {
      icon: '94.png',
      type: 'damage',
      inactive_adj: 0,
      name: '滚动的鹅毛笔',
      id: 'Artifact92',
      max: 50,
      effect: 0.0005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 3,
      tcoef: 0.125,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000255,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MSw',
    },
    art93: {
      icon: '95.png',
      type: 'damage',
      inactive_adj: 0,
      name: '老国王的邮票',
      id: 'Artifact93',
      max: 50,
      effect: 0.0005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 0.8,
      ccoef: 0.5,
      cexpo: 3,
      tcoef: 0.125,
      texpo: 4,
      gpeak: 1,
      adcalc: 0.000255,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'MSw',
    },
    art85: {
      icon: '48.png',
      type: 'damage',
      inactive_adj: 0,
      name: '大师之剑',
      id: 'Artifact49',
      max: 40,
      effect: 0.0001,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TMS',
    },
    art86: {
      icon: '13.png',
      type: 'damage',
      inactive_adj: 0,
      name: '能量倍增',
      id: 'Artifact80',
      max: 40,
      effect: 0.225,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 2,
      cexpo: 3,
      tcoef: 0.5,
      texpo: 4,
      gpeak: 1,
      adcalc: 46.138649,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'Mag',
    },
    art87: {
      icon: '09.png',
      type: 'damage',
      inactive_adj: 0,
      name: '金币倍增',
      id: 'Artifact81',
      max: 40,
      effect: 0.225,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 2,
      cexpo: 3,
      tcoef: 0.5,
      texpo: 4,
      gpeak: 1,
      adcalc: 46.138649,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TToF',
    },
    art88: {
      icon: '18.png',
      type: 'damage',
      inactive_adj: 0,
      name: '矮人重锤',
      id: 'Artifact85',
      max: 50,
      effect: 0.005,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 3,
      ccoef: 2,
      cexpo: 3,
      tcoef: 0.5,
      texpo: 4,
      gpeak: 1,
      adcalc: 46.138649,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'TWD',
    },
    art89: {
      icon: '22.png',
      type: 'damage',
      inactive_adj: 0,
      name: '亚兰之矛',
      id: 'Artifact57',
      max: 40,
      effect: 0.02,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'AS',
    },
    art90: {
      icon: '41.png',
      type: 'damage',
      inactive_adj: 0,
      name: '暗黑守卫',
      id: 'Artifact60',
      max: 60,
      effect: 1,
      gmax: 0,
      grate: 0,
      gexpo: 1,
      ad: 2,
      ccoef: 0.5,
      cexpo: 2.6,
      tcoef: 0.1389,
      texpo: 3.6,
      gpeak: 1,
      adcalc: 0.058515,
      reductions_orig: {
        cs: 0,
        sc: 0,
        pet: 0,
        hs: 0,
        hscs: 0,
        hssc: 0,
        phom: 0,
        fairy: 0,
        chest: 0,
        boss: 0,
      },
      weffect: 0,
      wcost: 0,
      costpct: 0,
      adpct: 0,
      calcrelic: 0,
      calclevel: 0,
      nickname: 'WotD',
    },
  },
  artifact_count: 95,
  artifact_costs: {
    0: -1,
    1: 1,
    2: 3,
    3: 6,
    4: 11,
    5: 19,
    6: 30,
    7: 46,
    8: 69,
    9: 102,
    10: 148,
    11: 214,
    12: 306,
    13: 434,
    14: 613,
    15: 861,
    16: 1203,
    17: 1675,
    18: 2323,
    19: 3212,
    20: 4430,
    21: 6094,
    22: 8363,
    23: 11454,
    24: 15657,
    25: 21365,
    26: 29108,
    27: 39599,
    28: 53796,
    29: 72990,
    30: 98914,
    31: 133897,
    32: 181063,
    33: 244605,
    34: 330143,
    35: 445208,
    36: 599886,
    37: 807680,
    38: 1086657,
    39: 1460982,
    40: 1962961,
    41: 2801512,
    42: 4271796,
    43: 6546742,
    44: 10084102,
    45: 15611565,
    46: 24291381,
    47: 37988598,
    48: 59710114,
    49: 94326541,
    50: 149764436,
    51: 238984254,
    52: 383276658,
    53: 617780678,
    54: 1000762985,
    55: 1629292101,
    56: 2665833882,
    57: 4383580899,
    58: 7244059100,
    59: 12030591779,
    60: 20078853673,
    61: 33676929221,
    62: 56762601881,
    63: 96144140647,
    64: 163647145909,
    65: 279906771691,
    66: 3840000000000,
    67: 53170000000000,
    68: 738330000000000,
    69: 10300000000000000,
    70: 144000000000000000,
    71: 2030000000000000000,
    72: 28800000000000000000,
    73: 409000000000000000000,
    74: 5.85e21,
    75: 8.42e22,
    76: 1.21e24,
    77: 1.76e25,
    78: 2.56e26,
    79: 3.74e27,
    80: 5.5e28,
    81: 8.12e29,
    82: 1.2e31,
    83: 1.78e32,
    84: 2.69e33,
    85: 4.04e34,
    86: 6.11e35,
    87: 9.27e36,
    88: 1.41e38,
    89: 2.17e39,
    90: 3.33e40,
    91: -1,
  },
  artifact_lookup: {
    Artifact22: 'art1',
    Artifact2: 'art2',
    Artifact19: 'art3',
    Artifact1: 'art4',
    Artifact20: 'art5',
    Artifact66: 'art6',
    Artifact43: 'art7',
    Artifact44: 'art8',
    Artifact45: 'art9',
    Artifact79: 'art10',
    Artifact82: 'art11',
    Artifact84: 'art12',
    Artifact26: 'art13',
    Artifact31: 'art14',
    Artifact29: 'art15',
    Artifact51: 'art16',
    Artifact59: 'art17',
    Artifact83: 'art18',
    Artifact35: 'art19',
    Artifact32: 'art20',
    Artifact33: 'art21',
    Artifact34: 'art22',
    Artifact61: 'art23',
    Artifact62: 'art24',
    Artifact38: 'art25',
    Artifact30: 'art26',
    Artifact64: 'art27',
    Artifact52: 'art28',
    Artifact53: 'art29',
    Artifact67: 'art30',
    Artifact42: 'art31',
    Artifact46: 'art32',
    Artifact55: 'art33',
    Artifact56: 'art34',
    Artifact75: 'art35',
    Artifact76: 'art36',
    Artifact77: 'art37',
    Artifact78: 'art38',
    Artifact40: 'art39',
    Artifact25: 'art40',
    Artifact17: 'art41',
    Artifact23: 'art42',
    Artifact73: 'art43',
    Artifact28: 'art44',
    Artifact86: 'art45',
    Artifact87: 'art46',
    Artifact88: 'art47',
    Artifact89: 'art48',
    Artifact90: 'art49',
    Artifact47: 'art50',
    Artifact11: 'art51',
    Artifact41: 'art52',
    Artifact9: 'art53',
    Artifact10: 'art54',
    Artifact7: 'art55',
    Artifact6: 'art56',
    Artifact65: 'art57',
    Artifact48: 'art58',
    Artifact13: 'art59',
    Artifact15: 'art60',
    Artifact16: 'art61',
    Artifact14: 'art62',
    Artifact12: 'art63',
    Artifact36: 'art64',
    Artifact27: 'art65',
    Artifact39: 'art66',
    Artifact37: 'art67',
    Artifact3: 'art68',
    Artifact8: 'art69',
    Artifact50: 'art70',
    Artifact58: 'art71',
    Artifact68: 'art72',
    Artifact18: 'art73',
    Artifact21: 'art74',
    Artifact5: 'art75',
    Artifact4: 'art76',
    Artifact54: 'art77',
    Artifact70: 'art78',
    Artifact74: 'art79',
    Artifact72: 'art80',
    Artifact69: 'art81',
    Artifact63: 'art82',
    Artifact24: 'art83',
    Artifact71: 'art84',
    Artifact49: 'art85',
    Artifact80: 'art86',
    Artifact81: 'art87',
    Artifact85: 'art88',
    Artifact57: 'art89',
    Artifact60: 'art90',
    Artifact95: 'art95',
    Artifact94: 'art94',
    Artifact93: 'art93',
    Artifact92: 'art92',
    Artifact91: 'art91',
  },
  skills: [
    {
      id: 'gray11',
      name: '骑士之勇',
      type: 'Knight',
      icon: 'gray11.png',
      tier: 1,
      column: 0,
      need: 0,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.2 点击伤害',
        '×1.71 点击伤害',
        '×2.43 点击伤害',
        '×3.82 点击伤害',
        '×6.02 点击伤害',
        '×9.47 点击伤害',
        '×16.4 点击伤害',
        '×31.4 点击伤害',
        '×60.1 点击伤害',
        '×126 点击伤害',
        '×290 点击伤害',
        '×728 点击伤害',
        '×2K 点击伤害',
        '×6.49K 点击伤害',
        '×22.9K 点击伤害',
        '×94.8K 点击伤害',
        '×459K 点击伤害',
        '×2.79M 点击伤害',
        '×21.1M 点击伤害',
        '×197M 点击伤害',
        '×2.27B 点击伤害',
        '×36.5B 点击伤害',
        '×815M 点击伤害',
        '×25T 点击伤害',
        '×1.19e015 点击伤害',
      ],
    },
    {
      id: 'gray21',
      name: '骑士勋章',
      type: 'Knight',
      icon: 'gray21.png',
      tier: 2,
      column: 1,
      need: 3,
      costs: [
        1, 2, 2, 3, 4, 4, 5, 6, 8, 10, 12, 14, 17, 21, 25, 31, 37, 45, 55, 67,
      ],
      effects: [
        '×1.28 来自英雄的点击伤害加成',
        '×1.55 来自英雄的点击伤害加成',
        '×1.9 来自英雄的点击伤害加成',
        '×2.6 来自英雄的点击伤害加成',
        '×3.3 来自英雄的点击伤害加成',
        '×4.77 来自英雄的点击伤害加成',
        '×6.57 来自英雄的点击伤害加成',
        '×11.23 来自英雄的点击伤害加成',
        '×21.34 来自英雄的点击伤害加成',
        '×42.67 来自英雄的点击伤害加成',
        '×93.88 来自英雄的点击伤害加成',
        '×215.9 来自英雄的点击伤害加成',
        '×647.8 来自英雄的点击伤害加成',
        '×2.27K 来自英雄的点击伤害加成',
        '×10.70K 来自英雄的点击伤害加成',
        '×63.90K 来自英雄的点击伤害加成',
        '×510.99K 来自英雄的点击伤害加成',
        '×5.58M 来自英雄的点击伤害加成',
        '×147.00M 来自英雄的点击伤害加成',
        '×24.20B 来自英雄的点击伤害加成',
      ],
    },
    {
      id: 'gray22',
      name: '天使光辉',
      type: 'Knight',
      icon: 'gray22.png',
      tier: 2,
      column: 2,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50, 57, 66, 76, 87, 100,
      ],
      effects: [
        '×2 天堂圣击伤害',
        '×3 天堂圣击伤害;+2 天堂圣击溅射数目',
        '×4.5 天堂圣击伤害;+4 天堂圣击溅射数目',
        '×7.5 天堂圣击伤害;+6 天堂圣击溅射数目',
        '×12.5 天堂圣击伤害;+8 天堂圣击溅射数目',
        '×20.8 天堂圣击伤害;+10 天堂圣击溅射数目',
        '×38.6 天堂圣击伤害;+12 天堂圣击溅射数目',
        '×78.9 天堂圣击伤害;+14 天堂圣击溅射数目',
        '×161 天堂圣击伤害;+16 天堂圣击溅射数目',
        '×364 天堂圣击伤害;+18 天堂圣击溅射数目',
        '×906 天堂圣击伤害;+20 天堂圣击溅射数目',
        '×2.48K 天堂圣击伤害;+22 天堂圣击溅射数目',
        '×7.42K 天堂圣击伤害;+24 天堂圣击溅射数目',
        '×26.60K 天堂圣击伤害;+27 天堂圣击溅射数目',
        '×104.00K 天堂圣击伤害;+30 天堂圣击溅射数目',
        '×486.00K 天堂圣击伤害;+33 天堂圣击溅射数目',
        '×2.67M 天堂圣击伤害;+36 天堂圣击溅射数目',
        '×18.80M 天堂圣击伤害;+39 天堂圣击溅射数目',
        '×167.00M 天堂圣击伤害;+42 天堂圣击溅射数目',
        '×1.87B 天堂圣击伤害;+45 天堂圣击溅射数目',
        '×26.30B 天堂圣击伤害;+48 天堂圣击溅射数目',
        '×532.00B 天堂圣击伤害;+51 天堂圣击溅射数目',
        '×15.40T 天堂圣击伤害;+54 天堂圣击溅射数目',
        '×635.00T 天堂圣击伤害;+57 天堂圣击溅射数目',
        '×4.25e016 天堂圣击伤害;+60 天堂圣击溅射数目',
        '×4.58e018 天堂圣击伤害;+63 天堂圣击溅射数目',
        '×9.05e020 天堂圣击伤害;+66 天堂圣击溅射数目',
        '×3.50e023 天堂圣击伤害;+69 天堂圣击溅射数目',
        '×2.82e026 天堂圣击伤害;+72 天堂圣击溅射数目',
        '×5.43e029 天堂圣击伤害;+75 天堂圣击溅射数目',
      ],
    },
    {
      id: 'gray23',
      name: '终极米达斯',
      type: 'Knight',
      icon: 'gray23.png',
      tier: 2,
      column: 3,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.8 点金之手金币数量;+1秒 点金之手持续时间',
        '×2.92 点金之手金币数量;+2秒 点金之手持续时间',
        '×4.79 点金之手金币数量;+4秒 点金之手持续时间',
        '×8.78 点金之手金币数量;+7秒 点金之手持续时间',
        '×16.1 点金之手金币数量;+9秒 点金之手持续时间',
        '×29.5 点金之手金币数量;+12秒 点金之手持续时间',
        '×60.2 点金之手金币数量;+16秒 点金之手持续时间',
        '×136 点金之手金币数量;+21秒 点金之手持续时间',
        '×309 点金之手金币数量;+26秒 点金之手持续时间',
        '×776 点金之手金币数量;+33秒 点金之手持续时间',
        '×2.15K 点金之手金币数量;+41秒 点金之手持续时间',
        '×6.59K 点金之手金币数量;+51秒 点金之手持续时间',
        '×22.20K 点金之手金币数量;+63秒 点金之手持续时间',
        '×90.20K 点金之手金币数量;+77秒 点金之手持续时间',
        '×401.99K 点金之手金币数量;+95秒 点金之手持续时间',
        '×2.14M 点金之手金币数量;+115秒 点金之手持续时间',
        '×13.50M 点金之手金币数量;+142秒 点金之手持续时间',
        '×110.00M 点金之手金币数量;+173秒 点金之手持续时间',
        '×1.13B 点金之手金币数量;+211秒 点金之手持续时间',
        '×15.00B 点金之手金币数量;+255秒 点金之手持续时间',
        '×249.00B 点金之手金币数量;+310秒 点金之手持续时间',
        '×6.01T 点金之手金币数量;+376秒 点金之手持续时间',
        '×210.00T 点金之手金币数量;+454秒 点金之手持续时间',
        '×1.05e016 点金之手金币数量;+550秒 点金之手持续时间',
        '×8.64e017 点金之手金币数量;+664秒 点金之手持续时间',
      ],
    },
    {
      id: 'gray31',
      name: '劈砍',
      type: 'Knight',
      icon: 'gray31.png',
      tier: 3,
      column: 1,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×1.6 最高暴击伤害;-1% 暴击几率',
        '×2.38 最高暴击伤害;-2% 暴击几率',
        '×3.93 最高暴击伤害;-3% 暴击几率',
        '×6.48 最高暴击伤害;-4% 暴击几率',
        '×10.7 最高暴击伤害;-5% 暴击几率',
        '×19.5 最高暴击伤害;-6% 暴击几率',
        '×39.4 最高暴击伤害;-7% 暴击几率',
        '×79.4 最高暴击伤害;-8% 暴击几率',
        '×176 最高暴击伤害;-9% 暴击几率',
        '×431 最高暴击伤害;-10% 暴击几率',
        '×1.14K 最高暴击伤害;-11% 暴击几率',
        '×3.39K 最高暴击伤害;-12% 暴击几率',
        '×11.90K 最高暴击伤害;-13% 暴击几率',
        '×45.80K 最高暴击伤害;-14% 暴击几率',
        '×209.00K 最高暴击伤害;-15% 暴击几率',
        '×1.12M 最高暴击伤害;-16% 暴击几率',
        '×7.74M 最高暴击伤害;-17% 暴击几率',
        '×67.69M 最高暴击伤害;-18% 暴击几率',
        '×745.00M 最高暴击伤害;-19% 暴击几率',
        '×10.30B 最高暴击伤害;-20% 暴击几率',
        '×205.00B 最高暴击伤害;-21% 暴击几率',
        '×5.86T 最高暴击伤害;-22% 暴击几率',
        '×239.00T 最高暴击伤害;-23% 暴击几率',
        '×1.57e016 最高暴击伤害;-24% 暴击几率',
        '×1.67e018 最高暴击伤害;-25% 暴击几率',
      ],
    },
    {
      id: 'gray32',
      name: '恢复活力',
      type: 'Knight',
      icon: 'gray32.png',
      tier: 3,
      column: 2,
      need: 20,
      costs: [4, 7, 13, 23, 42, 76, 136],
      effects: [
        '×0.95 天堂圣击蓝耗;+7 天堂圣击溅射跳关数',
        '×0.9 天堂圣击蓝耗;+14 天堂圣击溅射跳关数',
        '×0.85 天堂圣击蓝耗;+21 天堂圣击溅射跳关数',
        '×0.8 天堂圣击蓝耗;+28 天堂圣击溅射跳关数',
        '×0.75 天堂圣击蓝耗;+35 天堂圣击溅射跳关数',
        '×0.7 天堂圣击蓝耗;+42 天堂圣击溅射跳关数',
        '×0.65 天堂圣击蓝耗;+49 天堂圣击溅射跳关数',
      ],
    },
    {
      id: 'gray33',
      name: '迈达斯的意志',
      type: 'Knight',
      icon: 'gray33.png',
      tier: 3,
      column: 3,
      need: 20,
      costs: [2, 3, 5, 8, 12, 16, 21, 29, 41, 57],
      effects: [
        '×2.4 仙女金币数量',
        '×4.5 仙女金币数量',
        '×10.6 仙女金币数量',
        '×34.2 仙女金币数量',
        '×164 仙女金币数量',
        '×1.12K 仙女金币数量',
        '×12.00K 仙女金币数量',
        '×238.00K 仙女金币数量',
        '×11.40M 仙女金币数量',
        '×1.62B 仙女金币数量',
      ],
    },
    {
      id: 'gray41',
      name: '野蛮之怒',
      type: 'Knight',
      icon: 'gray41.png',
      tier: 4,
      column: 1,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×2.5 主动点击伤害;+1 每秒额外点击数',
        '×6.19 主动点击伤害;+2 每秒额外点击数',
        '×17.7 主动点击伤害;+3 每秒额外点击数',
        '×66.6 主动点击伤害;+4 每秒额外点击数',
        '×325 主动点击伤害;+5 每秒额外点击数',
        '×2.27K 主动点击伤害;+6 每秒额外点击数',
        '×25.10K 主动点击伤害;+8 每秒额外点击数',
        '×463.00K 主动点击伤害;+10 每秒额外点击数',
        '×15.30M 主动点击伤害;+12 每秒额外点击数',
        '×1.04B 主动点击伤害;+15 每秒额外点击数',
        '×180.00B 主动点击伤害;+18 每秒额外点击数',
        '×96.20T 主动点击伤害;+21 每秒额外点击数',
        '×2.09e017 主动点击伤害;+24 每秒额外点击数',
        '×2.63e021 主动点击伤害;+27 每秒额外点击数',
        '×3.21e026 主动点击伤害;+30 每秒额外点击数',
      ],
    },
    {
      id: 'gray42',
      name: '神的愤怒',
      type: 'Knight',
      icon: 'gray42.png',
      tier: 4,
      column: 2,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 每层多重施法伤害;+1 多重施法次数',
        '×1.62 每层多重施法伤害;+1 多重施法次数',
        '×2.14 每层多重施法伤害;+1 多重施法次数',
        '×3.04 每层多重施法伤害;+1 多重施法次数',
        '×4.63 每层多重施法伤害;+1 多重施法次数',
        '×7.76 每层多重施法伤害;+2 多重施法次数',
        '×14.6 每层多重施法伤害;+2 多重施法次数',
        '×31.7 每层多重施法伤害;+2 多重施法次数',
        '×80.1 每层多重施法伤害;+2 多重施法次数',
        '×245 每层多重施法伤害;+2 多重施法次数',
        '×960 每层多重施法伤害;+3 多重施法次数',
        '×5.08K 每层多重施法伤害;+3 多重施法次数',
        '×38.90K 每层多重施法伤害;+3 多重施法次数',
        '×475.00K 每层多重施法伤害;+3 多重施法次数',
        '×10.60M 每层多重施法伤害;+3 多重施法次数',
      ],
    },
    {
      id: 'gray43',
      name: '闪电穿梭',
      type: 'Knight',
      icon: 'gray43.png',
      tier: 4,
      column: 3,
      need: 50,
      costs: [2, 2, 3, 3, 3, 4, 5, 5, 6, 7],
      effects: [
        '+4% 多重仙女几率;-4秒 仙女再生冷却时间',
        '+16% 多重仙女几率;-8.6秒 仙女再生冷却时间',
        '+35% 多重仙女几率;-13.5秒 仙女再生冷却时间',
        '+54% 多重仙女几率;-18.8秒 仙女再生冷却时间',
        '+75% 多重仙女几率;-24.5秒 仙女再生冷却时间',
        '+103% 多重仙女几率;-30.6秒 仙女再生冷却时间',
        '+138% 多重仙女几率;-37.2秒 仙女再生冷却时间',
        '+176% 多重仙女几率;-44.2秒 仙女再生冷却时间',
        '+221% 多重仙女几率;-51.8秒 仙女再生冷却时间',
        '+275% 多重仙女几率;-60秒 仙女再生冷却时间',
      ],
    },
    {
      id: 'red11',
      name: '宠物进化',
      type: 'Summoner',
      icon: 'red11.png',
      tier: 1,
      column: 0,
      need: 0,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.5 宠物伤害',
        '×2.21 宠物伤害;-1 激活宠物攻击所需点击次数',
        '×3.24 宠物伤害;-1 激活宠物攻击所需点击次数',
        '×5.26 宠物伤害;-2 激活宠物攻击所需点击次数',
        '×8.52 宠物伤害;-2 激活宠物攻击所需点击次数',
        '×13.8 宠物伤害;-3 激活宠物攻击所需点击次数',
        '×24.6 宠物伤害;-3 激活宠物攻击所需点击次数',
        '×48.3 宠物伤害;-4 激活宠物攻击所需点击次数',
        '×94.6 宠物伤害;-4 激活宠物攻击所需点击次数',
        '×203 宠物伤害;-5 激活宠物攻击所需点击次数',
        '×478 宠物伤害;-5 激活宠物攻击所需点击次数',
        '×1.23K 宠物伤害;-6 激活宠物攻击所需点击次数',
        '×3.43K 宠物伤害;-6 激活宠物攻击所需点击次数',
        '×11.40K 宠物伤害;-7 激活宠物攻击所需点击次数',
        '×41.30K 宠物伤害;-7 激活宠物攻击所需点击次数',
        '×176.00K 宠物伤害;-8 激活宠物攻击所需点击次数',
        '×876.99K 宠物伤害;-8 激活宠物攻击所需点击次数',
        '×5.53M 宠物伤害;-9 激活宠物攻击所需点击次数',
        '×43.80M 宠物伤害;-9 激活宠物攻击所需点击次数',
        '×433M 宠物伤害;-10 激活宠物攻击所需点击次数',
        '×5.32B 宠物伤害;-11 激活宠物攻击所需点击次数',
        '×93.30B 宠物伤害;-12 激活宠物攻击所需点击次数',
        '×2.31T 宠物伤害;-13 激活宠物攻击所需点击次数',
        '×80.70T 宠物伤害;-14 激活宠物攻击所需点击次数',
        '×4.50e015 宠物伤害;-15 激活宠物攻击所需点击次数',
      ],
    },
    {
      id: 'red21',
      name: '召唤地狱火',
      type: 'Summoner',
      icon: 'red21.png',
      tier: 2,
      column: 1,
      need: 3,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×1.6 烈焰火剑伤害;+1秒 烈焰火剑持续时间',
        '×2.37 烈焰火剑伤害;+2秒 烈焰火剑持续时间',
        '×3.86 烈焰火剑伤害;+4秒 烈焰火剑持续时间',
        '×6.38 烈焰火剑伤害;+7秒 烈焰火剑持续时间',
        '×10.5 烈焰火剑伤害;+9秒 烈焰火剑持续时间',
        '×19 烈焰火剑伤害;+12秒 烈焰火剑持续时间',
        '×37.9 烈焰火剑伤害;+16秒 烈焰火剑持续时间',
        '×75.6 烈焰火剑伤害;+21秒 烈焰火剑持续时间',
        '×166 烈焰火剑伤害;+26秒 烈焰火剑持续时间',
        '×401 烈焰火剑伤害;+33秒 烈焰火剑持续时间',
        '×1.06K 烈焰火剑伤害;+41秒 烈焰火剑持续时间',
        '×3.06K 烈焰火剑伤害;+51秒 烈焰火剑持续时间',
        '×10.60K 烈焰火剑伤害;+63秒 烈焰火剑持续时间',
        '×39.80K 烈焰火剑伤害;+77秒 烈焰火剑持续时间',
        '×177.00K 烈焰火剑伤害;+95秒 烈焰火剑持续时间',
        '×930.99K 烈焰火剑伤害;+115秒 烈焰火剑持续时间',
        '×6.23M 烈焰火剑伤害;+142秒 烈焰火剑持续时间',
        '×52.60M 烈焰火剑伤害;+173秒 烈焰火剑持续时间',
        '×559.00M 烈焰火剑伤害;+211秒 烈焰火剑持续时间',
        '×7.42B 烈焰火剑伤害;+255秒 烈焰火剑持续时间',
        '×142.00B 烈焰火剑伤害;+310秒 烈焰火剑持续时间',
        '×3.87T 烈焰火剑伤害;+376秒 烈焰火剑持续时间',
        '×149.00T 烈焰火剑伤害;+454秒 烈焰火剑持续时间',
        '×9.32e015 烈焰火剑伤害;+550秒 烈焰火剑持续时间',
        '×9.32e017 烈焰火剑伤害;+664秒 烈焰火剑持续时间',
      ],
    },
    {
      id: 'red22',
      name: '米达斯之心',
      type: 'Summoner',
      icon: 'red22.png',
      tier: 2,
      column: 2,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.8 头目金币',
        '×2.98 头目金币;-1秒 点金之心冷却时间',
        '×4.93 头目金币;-2秒 点金之心冷却时间',
        '×9.16 头目金币;-3秒 点金之心冷却时间',
        '×17 头目金币;-4秒 点金之心冷却时间',
        '×31.6 头目金币;-5秒 点金之心冷却时间',
        '×65.7 头目金币;-6秒 点金之心冷却时间',
        '×152 头目金币;-7秒 点金之心冷却时间',
        '×353 头目金币;-8秒 点金之心冷却时间',
        '×910 头目金币;-9秒 点金之心冷却时间',
        '×2.60K 头目金币;-10秒 点金之心冷却时间',
        '×8.24K 头目金币;-11秒 点金之心冷却时间',
        '×28.80K 头目金币;-12秒 点金之心冷却时间',
        '×122.00K 头目金币;-13秒 点金之心冷却时间',
        '×571.00K 头目金币;-14秒 点金之心冷却时间',
        '×3.20M 头目金币;-15秒 点金之心冷却时间',
        '×21.5M 头目金币;-16秒 点金之心冷却时间',
        '×186.00M 头目金币;-17秒 点金之心冷却时间',
        '×2.08B 头目金币;-18秒 点金之心冷却时间',
        '×29.80B 头目金币;-20秒 点金之心冷却时间',
        '×539.00B 头目金币;-22秒 点金之心冷却时间',
        '×14.40T 头目金币;-24秒 点金之心冷却时间',
        '×558.00T 头目金币;-26秒 点金之心冷却时间',
        '×3.14e016 头目金币;-28秒 点金之心冷却时间',
        '×2.92e018 头目金币;-30秒 点金之心冷却时间',
      ],
    },
    {
      id: 'red23',
      name: '伴侣战争',
      type: 'Summoner',
      icon: 'red23.png',
      tier: 2,
      column: 3,
      need: 3,
      costs: [5, 8, 11, 17, 25, 38, 57, 85, 128, 192],
      effects: [
        '×1.3 设备宠物效果;+2 双突发飞溅计数',
        '×1.66 设备宠物效果;+4 双突发飞溅计数',
        '×2.29 设备宠物效果;+6 双突发飞溅计数',
        '×3.69 设备宠物效果;+8 双突发飞溅计数',
        '×7.25 设备宠物效果;+10 双突发飞溅计数',
        '×19.3 设备宠物效果;+12 双突发飞溅计数',
        '×78.2 设备宠物效果;+14 双突发飞溅计数',
        '×557 设备宠物效果;+16 双突发飞溅计数',
        '×8.93K 设备宠物效果;+18 双突发飞溅计数',
        '×442.00K 设备宠物效果;+20 双突发飞溅计数',
      ],
    },
    {
      id: 'red31',
      name: 'Ember艺术',
      type: 'Summoner',
      icon: 'red31.png',
      tier: 3,
      column: 1,
      need: 20,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.24 召唤提升;+2 宠物溅射数目',
        '×1.5 召唤提升;+4 宠物溅射数目',
        '×1.91 召唤提升;+6 宠物溅射数目',
        '×2.43 召唤提升;+8 宠物溅射数目',
        '×3.1 召唤提升;+10 宠物溅射数目',
        '×4.18 召唤提升;+12 宠物溅射数目',
        '×5.93 召唤提升;+14 宠物溅射数目',
        '×8.41 召唤提升;+16 宠物溅射数目',
        '×12.6 召唤提升;+18 宠物溅射数目',
        '×19.8 召唤提升;+20 宠物溅射数目',
        '×32.7 召唤提升;+22 宠物溅射数目',
        '×56.7 召唤提升;+24 宠物溅射数目',
        '×108 召唤提升;+26 宠物溅射数目',
        '×217 召唤提升;+28 宠物溅射数目',
        '×478 召唤提升;+30 宠物溅射数目',
        '×1.14K 召唤提升;+32 宠物溅射数目',
        '×3.16K 召唤提升;+34 宠物溅射数目',
        '×9.86K 召唤提升;+36 宠物溅射数目',
        '×35.00K 召唤提升;+38 宠物溅射数目',
        '×140.00K 召唤提升;+40 宠物溅射数目',
        '×690.00K 召唤提升;+42 宠物溅射数目',
        '×4.13M 召唤提升;+44 宠物溅射数目',
        '×30.00M 召唤提升;+46 宠物溅射数目',
        '×2.85.00M 召唤提升;+48 宠物溅射数目',
        '×3.54B 召唤提升;+50 宠物溅射数目',
      ],
    },
    {
      id: 'red32',
      name: '闪电爆发',
      type: 'Summoner',
      icon: 'red32.png',
      tier: 3,
      column: 2,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57, 66, 76, 87, 100, 115,
      ],
      effects: [
        '×1.5 每次点击叠加的宠物伤害;+2 闪电攻击点击溅射数目',
        '×2.14 每次点击叠加的宠物伤害;+4 闪电攻击点击溅射数目',
        '×3.39 每次点击叠加的宠物伤害;+6 闪电攻击点击溅射数目',
        '×5.36 每次点击叠加的宠物伤害;+8 闪电攻击点击溅射数目',
        '×8.48 每次点击叠加的宠物伤害;+10 闪电攻击点击溅射数目',
        '×14.8 每次点击叠加的宠物伤害;+12 闪电攻击点击溅射数目',
        '×28.7 每次点击叠加的宠物伤害;+14 闪电攻击点击溅射数目',
        '×55.6 每次点击叠加的宠物伤害;+16 闪电攻击点击溅射数目',
        '×119 每次点击叠加的宠物伤害;+18 闪电攻击点击溅射数目',
        '×279 每次点击叠加的宠物伤害;+20 闪电攻击点击溅射数目',
        '×719 每次点击叠加的宠物伤害;+22 闪电攻击点击溅射数目',
        '×2.04K 每次点击叠加的宠物伤害;+24 闪电攻击点击溅射数目',
        '×6.91K 每次点击叠加的宠物伤害;+26 闪电攻击点击溅射数目',
        '×25.70K 每次点击叠加的宠物伤害;+28 闪电攻击点击溅射数目',
        '×112.99K 每次点击叠加的宠物伤害;+30 闪电攻击点击溅射数目',
        '595.00K 每次点击叠加的宠物伤害;+33 闪电攻击点击溅射数目',
        '×4.01M 每次点击叠加的宠物伤害;+36 闪电攻击点击溅射数目',
        '×34.39M 每次点击叠加的宠物伤害;+39 闪电攻击点击溅射数目',
        '×375.00M 每次点击叠加的宠物伤害;+42 闪电攻击点击溅射数目',
        '×5.15B 每次点击叠加的宠物伤害;+45 闪电攻击点击溅射数目',
        '×104.00B 每次点击叠加的宠物伤害;+48 闪电攻击点击溅射数目',
        '×3.04T 每次点击叠加的宠物伤害;+51 闪电攻击点击溅射数目',
        '×128.00T 每次点击叠加的宠物伤害;+54 闪电攻击点击溅射数目',
        '×8.99e015 每次点击叠加的宠物伤害;+57 闪电攻击点击溅射数目',
        '×1.04e018 每次点击叠加的宠物伤害;+60 闪电攻击点击溅射数目',
        '×2.27e020 每次点击叠加的宠物伤害;+63 闪电攻击点击溅射数目',
        '×1.00e023 每次点击叠加的宠物伤害;+66 闪电攻击点击溅射数目',
        '×9.59e025 每次点击叠加的宠物伤害;+69 闪电攻击点击溅射数目',
        '×2.29e029 每次点击叠加的宠物伤害;+72 闪电攻击点击溅射数目',
        '×1.57e033 每次点击叠加的宠物伤害;+75 闪电攻击点击溅射数目',
      ],
    },
    {
      id: 'red33',
      name: '召唤圈',
      type: 'Summoner',
      icon: 'red33.png',
      tier: 3,
      column: 3,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×1.4 双重伤害;+2秒 双重召唤时间',
        '×2.64 双重伤害;+5秒 双重召唤时间',
        '×5.46 双重伤害;+9秒 双重召唤时间',
        '×11.3 双重伤害;+13秒 双重召唤时间',
        '×23.4 双重伤害;+18秒 双重召唤时间',
        '×53.1 双重伤害;+24秒 双重召唤时间',
        '×132 双重伤害;+33秒 双重召唤时间',
        '×327 双重伤害;+41秒 双重召唤时间',
        '×888 双重伤害;+53秒 双重召唤时间',
        '×2.63K 双重伤害;+66秒 双重召唤时间',
        '×8.47K 双重伤害;+83秒 双重召唤时间',
        '×29.70K 双重伤害;+102秒 双重召唤时间',
        '×123.00K 双重伤害;+127秒 双重召唤时间',
        '×550.00K 双重伤害;+155秒 双重召唤时间',
        '×2.89M 双重伤害;+190秒 双重召唤时间',
        '17.70M 双重伤害;+231秒 双重召唤时间',
        '×136.00M 双重伤害;+283秒 双重召唤时间',
        '×1.30B 双重伤害;+347秒 双重召唤时间',
        '×15.50B 双重伤害;+422秒 双重召唤时间',
        '×227.99B 双重伤害;+510秒 双重召唤时间',
        '×4.72T 双重伤害;+620秒 双重召唤时间',
        '×137.99T 双重伤害;+752秒 双重召唤时间',
        '×5.60e015T 双重伤害;+908秒 双重召唤时间',
        '×3.60e017 双重伤害;+1.10K秒 双重召唤时间',
        '×3.65e019 双重伤害;+1.32K秒 双重召唤时间',
      ],
    },
    {
      id: 'red41',
      name: '火山爆发',
      type: 'Summoner',
      icon: 'red41.png',
      tier: 4,
      column: 1,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 每多播火剑的伤害;+1 火剑多播',
        '×1.62 每多播火剑的伤害;+1 火剑多播',
        '×2.14 每多播火剑的伤害;+1 火剑多播',
        '×3.04 每多播火剑的伤害;+1 火剑多播',
        '×4.63 每多播火剑的伤害;+1 火剑多播',
        '×7.76 每多播火剑的伤害;+2 火剑多播',
        '×14.6 每多播火剑的伤害;+2 火剑多播',
        '×31.7 每多播火剑的伤害;+2 火剑多播',
        '×80.1 每多播火剑的伤害;+2 火剑多播',
        '×245 每多播火剑的伤害;+2 火剑多播',
        '×960 每多播火剑的伤害;+3 火剑多播',
        '×5.08K 每多播火剑的伤害;+3 火剑多播',
        '×38.90K 每多播火剑的伤害;+3 火剑多播',
        '×475.00K 每多播火剑的伤害;+3 火剑多播',
        '×10.60M 每多播火剑的伤害;+3 火剑多播',
      ],
    },
    {
      id: 'red42',
      name: '闪电穿梭',
      type: 'Summoner',
      icon: 'red42.png',
      tier: 4,
      column: 2,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×2 已充能的宠物伤害;×0.965 宠物技能冷却',
        '×5.07 已充能的宠物伤害;×0.93 宠物技能冷却',
        '×14.9 已充能的宠物伤害;×0.895 宠物技能冷却',
        '×58.4 已充能的宠物伤害;×0.86 宠物技能冷却',
        '×298 已充能的宠物伤害;×0.825 宠物技能冷却',
        '×2.22K 已充能的宠物伤害;×0.79 宠物技能冷却',
        '×26.30K 已充能的宠物伤害;×0.755 宠物技能冷却',
        '×529.00K 已充能的宠物伤害;×0.72 宠物技能冷却',
        '×19.40M 已充能的宠物伤害;×0.685 宠物技能冷却',
        '×1.48B 已充能的宠物伤害;×0.65 宠物技能冷却',
        '×295.00B 已充能的宠物伤害;×0.615 宠物技能冷却',
        '×186.00T 已充能的宠物伤害;×0.58 宠物技能冷却',
        '×4.85e017 已充能的宠物伤害;×0.545 宠物技能冷却',
        '×7.48e021 已充能的宠物伤害;×0.51 宠物技能冷却',
        '×1.15e027 已充能的宠物伤害;×0.475 宠物技能冷却',
      ],
    },
    {
      id: 'red43',
      name: '燃烧的激情',
      type: 'Summoner',
      icon: 'red43.png',
      tier: 4,
      column: 3,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 每多播火剑的伤害;+1 火剑多播',
        '×1.62 每多播火剑的伤害;+1 火剑多播',
        '×2.14 每多播火剑的伤害;+1 火剑多播',
        '×3.04 每多播火剑的伤害;+1 火剑多播',
        '×4.63 每多播火剑的伤害;+1 火剑多播',
        '×7.76 每多播火剑的伤害;+2 火剑多播',
        '×14.6 每多播火剑的伤害;+2 火剑多播',
        '×31.7 每多播火剑的伤害;+2 火剑多播',
        '×80.1 每多播火剑的伤害;+2 火剑多播',
        '×245 每多播火剑的伤害;+2 火剑多播',
        '×960 每多播火剑的伤害;+3 火剑多播',
        '×5.08K 每多播火剑的伤害;+3 火剑多播',
        '×38.90K 每多播火剑的伤害;+3 火剑多播',
        '×475.00K 每多播火剑的伤害;+3 火剑多播',
        '×10.60M 每多播火剑的伤害;+3 火剑多播',
      ],
    },
    {
      id: 'yellow11',
      name: '指挥官',
      type: 'Warload',
      icon: 'yellow11.png',
      tier: 1,
      column: 0,
      need: 0,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.5 所有英雄伤害',
        '×1.71 所有英雄伤害',
        '×2.43 所有英雄伤害',
        '×3.82 所有英雄伤害',
        '×6.02 所有英雄伤害',
        '×9.47 所有英雄伤害',
        '×16.4 所有英雄伤害',
        '×31.4 所有英雄伤害',
        '×60.1 所有英雄伤害',
        '×126 所有英雄伤害',
        '×290 所有英雄伤害',
        '×728 所有英雄伤害',
        '×2.00K 所有英雄伤害',
        '×6.49K 所有英雄伤害',
        '×22.90K 所有英雄伤害',
        '×94.80K 所有英雄伤害',
        '×459.00K 所有英雄伤害',
        '×2.79M 所有英雄伤害',
        '×21.10M 所有英雄伤害',
        '×197M 所有英雄伤害',
        '×2.27B 所有英雄伤害',
        '×36.50B 所有英雄伤害',
        '×815.00B 所有英雄伤害',
        '×25.00T 所有英雄伤害',
        '×1.19e015 所有英雄伤害',
      ],
    },
    {
      id: 'yellow21',
      name: '战利品',
      type: 'Warload',
      icon: 'yellow21.png',
      tier: 2,
      column: 1,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.8 宝箱怪金币数量;+1% 宝箱怪出现几率',
        '×2.98 宝箱怪金币数量;+2% 宝箱怪出现几率',
        '×4.93 宝箱怪金币数量;+3% 宝箱怪出现几率',
        '×9.16 宝箱怪金币数量;+4% 宝箱怪出现几率',
        '×17 宝箱怪金币数量;+5% 宝箱怪出现几率',
        '×31.6 宝箱怪金币数量;+6% 宝箱怪出现几率',
        '×65.7 宝箱怪金币数量;+7% 宝箱怪出现几率',
        '×152 宝箱怪金币数量;+8% 宝箱怪出现几率',
        '×353 宝箱怪金币数量;+9% 宝箱怪出现几率',
        '×910 宝箱怪金币数量;+10% 宝箱怪出现几率',
        '×2.60K 宝箱怪金币数量;+11% 宝箱怪出现几率',
        '×8.24K 宝箱怪金币数量;+12% 宝箱怪出现几率',
        '×28.00K 宝箱怪金币数量;+13% 宝箱怪出现几率',
        '×122.00K 宝箱怪金币数量;+14% 宝箱怪出现几率',
        '×571.00K 宝箱怪金币数量;+15% 宝箱怪出现几率',
        '×3.20M 宝箱怪金币数量;+16% 宝箱怪出现几率',
        '×21.50M 宝箱怪金币数量;+17% 宝箱怪出现几率',
        '×186.00M 宝箱怪金币数量;+18% 宝箱怪出现几率',
        '×2.08B 宝箱怪金币数量;+19% 宝箱怪出现几率',
        '×29.80B 宝箱怪金币数量;+20% 宝箱怪出现几率',
        '×539.00B 宝箱怪金币数量;+21% 宝箱怪出现几率',
        '×14.40T 宝箱怪金币数量;+22% 宝箱怪出现几率',
        '×558.00T 宝箱怪金币数量;+23% 宝箱怪出现几率',
        '×3.14e016 宝箱怪金币数量;+24% 宝箱怪出现几率',
        '×2.92e018 宝箱怪金币数量;+25% 宝箱怪出现几率',
      ],
    },
    {
      id: 'yellow22',
      name: '英雄王者',
      type: 'Warload',
      icon: 'yellow22.png',
      tier: 2,
      column: 2,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.5 战争怒嚎伤害;+1 收鼓舞的英雄数量',
        '×2.13 战争怒嚎伤害;+2 收鼓舞的英雄数量',
        '×3.04 战争怒嚎伤害;+3 收鼓舞的英雄数量',
        '×4.79 战争怒嚎伤害;+4 收鼓舞的英雄数量',
        '×7.55 战争怒嚎伤害;+5 收鼓舞的英雄数量',
        '×11.9 战争怒嚎伤害;+6 收鼓舞的英雄数量',
        '×20.7 战争怒嚎伤害;+7 收鼓舞的英雄数量',
        '×39.7 战争怒嚎伤害;+8 收鼓舞的英雄数量',
        '×76.1 战争怒嚎伤害;+9 收鼓舞的英雄数量',
        '×160 战争怒嚎伤害;+10 收鼓舞的英雄数量',
        '×371 战争怒嚎伤害;+11 收鼓舞的英雄数量',
        '×939 战争怒嚎伤害;+12 收鼓舞的英雄数量',
        '×2.60K 战争怒嚎伤害;+13 收鼓舞的英雄数量',
        '×8.55K 战争怒嚎伤害;+14 收鼓舞的英雄数量',
        '×30.70K 战争怒嚎伤害;+15 收鼓舞的英雄数量',
        '×130.00K 战争怒嚎伤害;+16 收鼓舞的英雄数量',
        '×645.00K 战争怒嚎伤害;+17 收鼓舞的英雄数量',
        '×4.05M 战争怒嚎伤害;+18 收鼓舞的英雄数量',
        '×32.10M 战争怒嚎伤害;+19 收鼓舞的英雄数量',
        '×318.00M 战争怒嚎伤害;+20 收鼓舞的英雄数量',
        '×3.92B 战争怒嚎伤害;+22 收鼓舞的英雄数量',
        '×69.00B 战争怒嚎伤害;+24 收鼓舞的英雄数量',
        '×1.72T 战争怒嚎伤害;+26 收鼓舞的英雄数量',
        '×60.70T 战争怒嚎伤害;+28 收鼓舞的英雄数量',
        '×3.43e015 战争怒嚎伤害;+30 收鼓舞的英雄数量',
      ],
    },
    {
      id: 'yellow23',
      name: '空袭',
      type: 'Warload',
      icon: 'yellow23.png',
      tier: 2,
      column: 3,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.5 部落战舰伤害;+1 部落战舰溅射数目',
        '×2.11 部落战舰伤害;+2 部落战舰溅射数目',
        '×2.98 部落战舰伤害;+3 部落战舰溅射数目',
        '×4.63 部落战舰伤害;+4 部落战舰溅射数目',
        '×7.19 部落战舰伤害;+5 部落战舰溅射数目',
        '×11.2 部落战舰伤害;+6 部落战舰溅射数目',
        '×19.1 部落战舰伤害;+7 部落战舰溅射数目',
        '×35.8 部落战舰伤害;+8 部落战舰溅射数目',
        '×67.3 部落战舰伤害;+9 部落战舰溅射数目',
        '×138 部落战舰伤害;+10 部落战舰溅射数目',
        '×311 部落战舰伤害;+11 部落战舰溅射数目',
        '×763 部落战舰伤害;+12 部落战舰溅射数目',
        '×2.04K 部落战舰伤害;+13 部落战舰溅射数目',
        '×6.48 部落战舰伤害;+14 部落战舰溅射数目',
        '×22.30K 部落战舰伤害;+15 部落战舰溅射数目',
        '×90.20K 部落战舰伤害;+16 部落战舰溅射数目',
        '×426.99K 部落战舰伤害;+18 部落战舰溅射数目',
        '×2.54M 部落战舰伤害;+20 部落战舰溅射数目',
        '×19.10M 部落战舰伤害;+22 部落战舰溅射数目',
        '×177.00M 部落战舰伤害;+24 部落战舰溅射数目',
        '×2.04B 部落战舰伤害;+26 部落战舰溅射数目',
        '×33.59B 部落战舰伤害;+28 部落战舰溅射数目',
        '×776.00B 部落战舰伤害;+30 部落战舰溅射数目',
        '×25.20T 部落战舰伤害;+32 部落战舰溅射数目',
        '×1.30e015 部落战舰伤害;+35 部落战舰溅射数目',
      ],
    },
    {
      id: 'yellow31',
      name: '战略洞悉',
      type: 'Warload',
      icon: 'yellow31.png',
      tier: 3,
      column: 1,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×0.25% 英雄技能加成类别：乘法;+2% 英雄技能加成类别：加法',
        '×0.47% 英雄技能加成类别：乘法;+3.5% 英雄技能加成类别：加法',
        '×0.76% 英雄技能加成类别：乘法;+5% 英雄技能加成类别：加法',
        '×1.05% 英雄技能加成类别：乘法;+6.5% 英雄技能加成类别：加法',
        '×1.34% 英雄技能加成类别：乘法;+8% 英雄技能加成类别：加法',
        '×1.7% 英雄技能加成类别：乘法;+9.5% 英雄技能加成类别：加法',
        '×2.12% 英雄技能加成类别：乘法;+11% 英雄技能加成类别：加法',
        '×2.54% 英雄技能加成类别：乘法;+12.5% 英雄技能加成类别：加法',
        '×3.02% 英雄技能加成类别：乘法;+14% 英雄技能加成类别：加法',
        '×3.58% 英雄技能加成类别：乘法;+15.5% 英雄技能加成类别：加法',
        '×4.2% 英雄技能加成类别：乘法;+17% 英雄技能加成类别：加法',
        '×4.88% 英雄技能加成类别：乘法;+18.5% 英雄技能加成类别：加法',
        '×5.68% 英雄技能加成类别：乘法;+20% 英雄技能加成类别：加法',
        '×6.55% 英雄技能加成类别：乘法;+21.5% 英雄技能加成类别：加法',
        '×7.54% 英雄技能加成类别：乘法;+23% 英雄技能加成类别：加法',
        '×8.66% 英雄技能加成类别：乘法;+24.5% 英雄技能加成类别：加法',
        '×9.95% 英雄技能加成类别：乘法;+26% 英雄技能加成类别：加法',
        '×11.43% 英雄技能加成类别：乘法;+27.5% 英雄技能加成类别：加法',
        '×13.09% 英雄技能加成类别：乘法;+29% 英雄技能加成类别：加法',
        '×14.94% 英雄技能加成类别：乘法;+30.5% 英雄技能加成类别：加法',
        '×17.09% 英雄技能加成类别：乘法;+32% 英雄技能加成类别：加法',
        '×19.55% 英雄技能加成类别：乘法;+33.5% 英雄技能加成类别：加法',
        '×22.35% 英雄技能加成类别：乘法;+35% 英雄技能加成类别：加法',
        '×25.6% 英雄技能加成类别：乘法;+36.5% 英雄技能加成类别：加法',
        '×29.33% 英雄技能加成类别：乘法;+38% 英雄技能加成类别：加法',
      ],
    },
    {
      id: 'yellow32',
      name: '灼热之光',
      type: 'Warload',
      icon: 'yellow32.png',
      tier: 3,
      column: 2,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '+0.75% 受鼓舞的伤害增幅;+1秒 战争怒嚎持续时间',
        '+0.951% 受鼓舞的伤害增幅;+2秒 战争怒嚎持续时间',
        '+1.35% 受鼓舞的伤害增幅;+4秒 战争怒嚎持续时间',
        '+1.92% 受鼓舞的伤害增幅;+7秒 战争怒嚎持续时间',
        '+2.72% 受鼓舞的伤害增幅;+9秒 战争怒嚎持续时间',
        '+4.32% 受鼓舞的伤害增幅;+12秒 战争怒嚎持续时间',
        '+7.63% 受鼓舞的伤害增幅;+16秒 战争怒嚎持续时间',
        '+13.5% 受鼓舞的伤害增幅;+21秒 战争怒嚎持续时间',
        '+26.5% 受鼓舞的伤害增幅;+26秒 战争怒嚎持续时间',
        '+57.6% 受鼓舞的伤害增幅;+33秒 战争怒嚎持续时间',
        '+139% 受鼓舞的伤害增幅;+41秒 战争怒嚎持续时间',
        '+368% 受鼓舞的伤害增幅;+51秒 战争怒嚎持续时间',
        '+1.19K% 受鼓舞的伤害增幅;+63秒 战争怒嚎持续时间',
        '+4.20K% 受鼓舞的伤害增幅;+77秒 战争怒嚎持续时间',
        '+17.90K% 受鼓舞的伤害增幅;+95秒 战争怒嚎持续时间',
        '+91.10K% 受鼓舞的伤害增幅;+115秒 战争怒嚎持续时间',
        '+603.00K% 受鼓舞的伤害增幅;+142秒 战争怒嚎持续时间',
        '+5.15M% 受鼓舞的伤害增幅;+173秒 战争怒嚎持续时间',
        '+56.30M% 受鼓舞的伤害增幅;+211秒 战争怒嚎持续时间',
        '+785.00M% 受鼓舞的伤害增幅;+255秒 战争怒嚎持续时间',
        '+16.30B% 受鼓舞的伤害增幅;+310秒 战争怒嚎持续时间',
        '+496.00B% 受鼓舞的伤害增幅;+376秒 战争怒嚎持续时间',
        '+22.10T% 受鼓舞的伤害增幅;+454秒 战争怒嚎持续时间',
        '+1.67e015% 受鼓舞的伤害增幅;+550秒 战争怒嚎持续时间',
        '+2.11e017% 受鼓舞的伤害增幅;+664秒 战争怒嚎持续时间',
      ],
    },
    {
      id: 'yellow33',
      name: '协同进攻',
      type: 'Warload',
      icon: 'yellow33.png',
      tier: 3,
      column: 3,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×1.8 有效的总计英雄伤害',
        '×2.59 有效的总计英雄伤害;-1秒 协同进攻冷却时间',
        '×4.14 有效的总计英雄伤害;-2秒 协同进攻冷却时间',
        '×6.62 有效的总计英雄伤害;-3秒 协同进攻冷却时间',
        '×10.6 有效的总计英雄伤害;-4秒 协同进攻冷却时间',
        '×18.8 有效的总计英雄伤害;-5秒 协同进攻冷却时间',
        '×36.9 有效的总计英雄伤害;-6秒 协同进攻冷却时间',
        '×72.5 有效的总计英雄伤害;-7秒 协同进攻冷却时间',
        '×157 有效的总计英雄伤害;-8秒 协同进攻冷却时间',
        '×376 有效的总计英雄伤害;-9秒 协同进攻冷却时间',
        '×990 有效的总计英雄伤害;-10秒 协同进攻冷却时间',
        '×2.86K 有效的总计英雄伤害;-11秒 协同进攻冷却时间',
        '×9.93K 有效的总计英雄伤害;-12秒 协同进攻冷却时间',
        '×37.70K 有效的总计英雄伤害;-13秒 协同进攻冷却时间',
        '×170.00K 有效的总计英雄伤害;-14秒 协同进攻冷却时间',
        '×914.00K 有效的总计英雄伤害;-15秒 协同进攻冷却时间',
        '×6.29M 有效的总计英雄伤害;-16秒 协同进攻冷却时间',
        '×55.30M 有效的总计英雄伤害;-17秒 协同进攻冷却时间',
        '×616.00M 有效的总计英雄伤害;-18秒 协同进攻冷却时间',
        '×8.66B 有效的总计英雄伤害;-20秒 协同进攻冷却时间',
        '×178.00B 有效的总计英雄伤害;-22秒 协同进攻冷却时间',
        '×5.33T 有效的总计英雄伤害;-24秒 协同进攻冷却时间',
        '×230.00T 有效的总计英雄伤害;-26秒 协同进攻冷却时间',
        '×1.65e016 有效的总计英雄伤害;-28秒 协同进攻冷却时间',
        '×1.96e018 有效的总计英雄伤害;-30秒 协同进攻冷却时间',
      ],
    },
    {
      id: 'yellow41',
      name: '灵魂觉醒',
      type: 'Warload',
      icon: 'yellow41.png',
      tier: 4,
      column: 1,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.21 每激活一次叠加的全部英雄伤害',
        '×1.45 每激活一次叠加的全部英雄伤害',
        '×1.8 每激活一次叠加的全部英雄伤害',
        '×2.36 每激活一次叠加的全部英雄伤害',
        '×3.25 每激活一次叠加的全部英雄伤害',
        '×4.84 每激活一次叠加的全部英雄伤害',
        '×7.9 每激活一次叠加的全部英雄伤害',
        '×14.3 每激活一次叠加的全部英雄伤害',
        '×29.2 每激活一次叠加的全部英雄伤害',
        '×69.1 每激活一次叠加的全部英雄伤害',
        '×198 每激活一次叠加的全部英雄伤害',
        '×712 每激活一次叠加的全部英雄伤害',
        '×3.41K 每激活一次叠加的全部英雄伤害',
        '×23.40K 每激活一次叠加的全部英雄伤害',
        '×256.00K 每激活一次叠加的全部英雄伤害',
      ],
    },
    {
      id: 'yellow42',
      name: '命令疑云',
      type: 'Warload',
      icon: 'yellow42.png',
      tier: 4,
      column: 2,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 每多播呐喊的伤害;+1 呐喊多播',
        '×1.62 每多播呐喊的伤害;+1 呐喊多播',
        '×2.14 每多播呐喊的伤害;+1 呐喊多播',
        '×3.04 每多播呐喊的伤害;+1 呐喊多播',
        '×4.63 每多播呐喊的伤害;+1 呐喊多播',
        '×7.76 每多播呐喊的伤害;+2 呐喊多播',
        '×14.6 每多播呐喊的伤害;+2 呐喊多播',
        '×31.7 每多播呐喊的伤害;+2 呐喊多播',
        '×80.1 每多播呐喊的伤害;+2 呐喊多播',
        '×245 每多播呐喊的伤害;+2 呐喊多播',
        '×960 每多播呐喊的伤害;+3 呐喊多播',
        '×5.08K 每多播呐喊的伤害;+3 呐喊多播',
        '×38.90K 每多播呐喊的伤害;+3 呐喊多播',
        '×475.00K 每多播呐喊的伤害;+3 呐喊多播',
        '×10.60M 每多播呐喊的伤害;+3 呐喊多播',
      ],
    },
    {
      id: 'yellow43',
      name: '锚定射击',
      type: 'Warload',
      icon: 'yellow43.png',
      tier: 4,
      column: 3,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×3.5 重击伤害;+0.8秒 重击持续时间',
        '×10 重击伤害;+0.9秒 重击持续时间',
        '×33.6 重击伤害;+1秒 重击持续时间',
        '×153 重击伤害;+1.1秒 重击持续时间',
        '×925 重击伤害;+1.2秒 重击持续时间',
        '×8.34K 重击伤害;+1.3秒 重击持续时间',
        '×123.00K 重击伤害;+1.4秒 重击持续时间',
        '×3.18M 重击伤害;+1.5秒 重击持续时间',
        '×154.00M 重击伤害;+1.6秒 重击持续时间',
        '×16.10B 重击伤害;+1.7秒 重击持续时间',
        '×4.58T 重击伤害;+1.8秒 重击持续时间',
        '×4.28e015 重击伤害;+1.9秒 重击持续时间',
        '×1.73e019K 重击伤害;+2秒 重击持续时间',
        '×4.34e023 重击伤害;+2.1秒 重击持续时间',
        '×1.13e029 重击伤害;+2.2秒 重击持续时间',
      ],
    },
    {
      id: 'blue11',
      name: '幽魂复仇',
      type: 'Sorcerer',
      icon: 'blue11.png',
      tier: 1,
      column: 0,
      need: 0,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50, 57, 66, 76, 87, 100,
      ],
      effects: [
        '×1.5 幻影分身伤害;+0.1 幻影分身每秒攻击次数',
        '×2.06 幻影分身伤害;+0.21 幻影分身每秒攻击次数',
        '×2.84 幻影分身伤害;+0.33 幻影分身每秒攻击次数',
        '×4.34 幻影分身伤害;+0.46 幻影分身每秒攻击次数',
        '×6.64 幻影分身伤害;+0.59 幻影分身每秒攻击次数',
        '×10.2 幻影分身伤害;+0.74 幻影分身每秒攻击次数',
        '×17.2 幻影分身伤害;+0.89 幻影分身每秒攻击次数',
        '×32.4 幻影分身伤害;+1.05 幻影分身每秒攻击次数',
        '×60.9 幻影分身伤害;+1.22 幻影分身每秒攻击次数',
        '×126 幻影分身伤害;+1.41 幻影分身每秒攻击次数',
        '×289 幻影分身伤害;+1.6 幻影分身每秒攻击次数',
        '×727 幻影分身伤害;+1.81 幻影分身每秒攻击次数',
        '×2.00K 幻影分身伤害;+2.03 幻影分身每秒攻击次数',
        '×6.66K 幻影分身伤害;+2.26 幻影分身每秒攻击次数',
        '×24.20K 幻影分身伤害;+2.51 幻影分身每秒攻击次数',
        '×105.00K 幻影分身伤害;+2.77 幻影分身每秒攻击次数',
        '×537.00K 幻影分身伤害;+3.05 幻影分身每秒攻击次数',
        '×3.54M 幻影分身伤害;+3.35 幻影分身每秒攻击次数',
        '×29.70M 幻影分身伤害;+3.66 幻影分身每秒攻击次数',
        '×316.99M 幻影分身伤害;+4 幻影分身每秒攻击次数',
        '×4.26B 幻影分身伤害;+4.36 幻影分身每秒攻击次数',
        '×83.90B 幻影分身伤害;+4.74 幻影分身每秒攻击次数',
        '×2.40T 幻影分身伤害;+5.14 幻影分身每秒攻击次数',
        '×99.09T 幻影分身伤害;+5.57 幻影分身每秒攻击次数',
        '×6.81e015 幻影分身伤害;+6.02 幻影分身每秒攻击次数',
        '×7.73e017 幻影分身伤害;+6.51 幻影分身每秒攻击次数',
        '×1.67e020 幻影分身伤害;+7.02 幻影分身每秒攻击次数',
        '×7.36e022 幻影分身伤害;+7.56 幻影分身每秒攻击次数',
        '×7.09e025 幻影分身伤害;+8.14 幻影分身每秒攻击次数',
        '×1.73e029 幻影分身伤害;+8.76 幻影分身每秒攻击次数',
      ],
    },
    {
      id: 'blue21',
      name: '界限突破',
      type: 'Sorcerer',
      icon: 'blue21.png',
      tier: 2,
      column: 1,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '+5 魔法容量;+0.1 魔法恢复',
        '+8 魔法容量;+0.228 魔法恢复',
        '+12 魔法容量;+0.373 魔法恢复',
        '+19 魔法容量;+0.538 魔法恢复',
        '+26 魔法容量;+0.727 魔法恢复',
        '+35 魔法容量;+0.941 魔法恢复',
        '+46 魔法容量;+1.185 魔法恢复',
        '+62 魔法容量;+1.463 魔法恢复',
        '+80 魔法容量;+1.779 魔法恢复',
        '+103 魔法容量;+2.139 魔法恢复',
        '+132 魔法容量;+2.549 魔法恢复',
        '+168 魔法容量;+3.015 魔法恢复',
        '+213 魔法容量;+3.546 魔法恢复',
        '+269 魔法容量;+4.151 魔法恢复',
        '+337 魔法容量;+4.839 魔法恢复',
        '+421 魔法容量;+5.622 魔法恢复',
        '+524 魔法容量;+6.514 魔法恢复',
        '+652 魔法容量;+7.529 魔法恢复',
        '+809 魔法容量;+8.684 魔法恢复',
        '+1.00K 魔法容量;+10 魔法恢复',
        '+1.23K 魔法容量;+11.5 魔法恢复',
        '+1.52K 魔法容量;+13.2 魔法恢复',
        '+1.87K 魔法容量;+15.14 魔法恢复',
        '+2.29K 魔法容量;+17.35 魔法恢复',
        '+2.81K 魔法容量;+19.86 魔法恢复',
      ],
    },
    {
      id: 'blue22',
      name: '永恒黑暗',
      type: 'Sorcerer',
      icon: 'blue22.png',
      tier: 2,
      column: 2,
      need: 3,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '+2秒 幻影分身持续时间',
        '+5秒 幻影分身持续时间;+1 幻影分身溅射跳过数量',
        '+9秒 幻影分身持续时间;+2 幻影分身溅射跳过数量',
        '+13秒 幻影分身持续时间;+3 幻影分身溅射跳过数量',
        '+18秒 幻影分身持续时间;+4 幻影分身溅射跳过数量',
        '+24秒 幻影分身持续时间;+6 幻影分身溅射跳过数量',
        '+33秒 幻影分身持续时间;+8 幻影分身溅射跳过数量',
        '+41秒 幻影分身持续时间;+10 幻影分身溅射跳过数量',
        '+53秒 幻影分身持续时间;+12 幻影分身溅射跳过数量',
        '+66秒 幻影分身持续时间;+14 幻影分身溅射跳过数量',
        '+83秒 幻影分身持续时间;+16 幻影分身溅射跳过数量',
        '+102秒 幻影分身持续时间;+18 幻影分身溅射跳过数量',
        '+127秒 幻影分身持续时间;+20 幻影分身溅射跳过数量',
        '+155秒 幻影分身持续时间;+23 幻影分身溅射跳过数量',
        '+190秒 幻影分身持续时间;+26 幻影分身溅射跳过数量',
        '+231秒 幻影分身持续时间;+29 幻影分身溅射跳过数量',
        '+283秒 幻影分身持续时间;+33 幻影分身溅射跳过数量',
        '+347秒 幻影分身持续时间;+38 幻影分身溅射跳过数量',
        '+422秒 幻影分身持续时间;+44 幻影分身溅射跳过数量',
        '+510秒 幻影分身持续时间;+51 幻影分身溅射跳过数量',
        '+620秒 幻影分身持续时间;+59 幻影分身溅射跳过数量',
        '+752秒 幻影分身持续时间;+68 幻影分身溅射跳过数量',
        '+908秒 幻影分身持续时间;+78 幻影分身溅射跳过数量',
        '+1.10K秒 幻影分身持续时间;+89 幻影分身溅射跳过数量',
        '+1.32K秒 幻影分身持续时间;+101 幻影分身溅射跳过数量',
      ],
    },
    {
      id: 'blue23',
      name: '法力虹吸',
      type: 'Sorcerer',
      icon: 'blue23.png',
      tier: 2,
      column: 3,
      need: 3,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '0.05% 每次点击恢复的魔法量',
        '0.07% 每次点击恢复的魔法量',
        '0.1% 每次点击恢复的魔法量',
        '0.13% 每次点击恢复的魔法量',
        '0.16% 每次点击恢复的魔法量',
        '0.2% 每次点击恢复的魔法量',
        '0.25% 每次点击恢复的魔法量',
        '0.31% 每次点击恢复的魔法量',
        '0.38% 每次点击恢复的魔法量',
        '0.47% 每次点击恢复的魔法量',
        '0.56% 每次点击恢复的魔法量',
        '0.68% 每次点击恢复的魔法量',
        '0.81% 每次点击恢复的魔法量',
        '0.97% 每次点击恢复的魔法量',
        '1.15% 每次点击恢复的魔法量',
        '1.37% 每次点击恢复的魔法量',
        '1.62% 每次点击恢复的魔法量',
        '1.92% 每次点击恢复的魔法量',
        '2.26% 每次点击恢复的魔法量',
        '2.65% 每次点击恢复的魔法量',
        '3.12% 每次点击恢复的魔法量',
        '3.66% 每次点击恢复的魔法量',
        '4.28% 每次点击恢复的魔法量',
        '5.01% 每次点击恢复的魔法量',
        '5.84% 每次点击恢复的魔法量',
      ],
    },
    {
      id: 'blue31',
      name: '仙女魔力',
      type: 'Sorcerer',
      icon: 'blue31.png',
      tier: 3,
      column: 1,
      need: 20,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '+2 已恢复魔法',
        '+4 已恢复魔法',
        '+6.5 已恢复魔法',
        '+10 已恢复魔法',
        '+14.5 已恢复魔法',
        '+20.5 已恢复魔法',
        '+28.5 已恢复魔法',
        '+39 已恢复魔法',
        '+52.5 已恢复魔法',
        '+70 已恢复魔法',
        '+93 已恢复魔法',
        '+123 已恢复魔法',
        '+162 已恢复魔法',
        '+212.5 已恢复魔法',
        '+278 已恢复魔法',
      ],
    },
    {
      id: 'blue32',
      name: '相位转移',
      type: 'Sorcerer',
      icon: 'blue32.png',
      tier: 3,
      column: 2,
      need: 20,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.31 幻影分身首要主动技能效果;×1.042 技能激活持续时间',
        '×1.7 幻影分身首要主动技能效果;×1.087 技能激活持续时间',
        '×2.31 幻影分身首要主动技能效果;×1.136 技能激活持续时间',
        '×3.4 幻影分身首要主动技能效果;×1.19 技能激活持续时间',
        '×5.4 幻影分身首要主动技能效果;×1.25 技能激活持续时间',
        '×9.54 幻影分身首要主动技能效果;×1.316 技能激活持续时间',
        '×19.2 幻影分身首要主动技能效果;×1.389 技能激活持续时间',
        '×44.9 幻影分身首要主动技能效果;×1.471 技能激活持续时间',
        '×125 幻影分身首要主动技能效果;×1.563 技能激活持续时间',
        '×426 幻影分身首要主动技能效果;×1.667 技能激活持续时间',
        '×1.92 幻影分身首要主动技能效果;×1.818 技能激活持续时间',
        '×12.00K 幻影分身首要主动技能效果;×2 技能激活持续时间',
        '×112.99K 幻影分身首要主动技能效果;×2.222 技能激活持续时间',
        '×1.77M 幻影分身首要主动技能效果;×2.5 技能激活持续时间',
        '×53.90M 幻影分身首要主动技能效果;×2.857 技能激活持续时间',
      ],
    },
    {
      id: 'blue33',
      name: '闪电打击',
      type: 'Sorcerer',
      icon: 'blue33.png',
      tier: 3,
      column: 3,
      need: 20,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '+10% 泰坦生命值减免;93.8% 闪电伤害效率',
        '+15.32% 泰坦生命值减免;94.1% 闪电伤害效率',
        '+20.72% 泰坦生命值减免;94.4% 闪电伤害效率',
        '+26.71% 泰坦生命值减免;94.7% 闪电伤害效率',
        '+32.88% 泰坦生命值减免;95% 闪电伤害效率',
        '+39.42% 泰坦生命值减免;95.3% 闪电伤害效率',
        '+46.27% 泰坦生命值减免;95.6% 闪电伤害效率',
        '+53.23% 泰坦生命值减免;95.9% 闪电伤害效率',
        '+60.03% 泰坦生命值减免;96.2% 闪电伤害效率',
        '+66.59% 泰坦生命值减免;96.5% 闪电伤害效率',
        '+72.88% 泰坦生命值减免;96.8% 闪电伤害效率',
        '+78.67% 泰坦生命值减免;97.1% 闪电伤害效率',
        '+83.79% 泰坦生命值减免;97.4% 闪电伤害效率',
        '+88.09% 泰坦生命值减免;97.7% 闪电伤害效率',
        '+91.47% 泰坦生命值减免;98% 闪电伤害效率',
      ],
    },
    {
      id: 'blue41',
      name: '禁忌秘术',
      type: 'Sorcerer',
      icon: 'blue41.png',
      tier: 4,
      column: 1,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '+316 故宫合同最大伤害;+60秒 直到最大伤害',
        '+963 故宫合同最大伤害;+57.8秒 直到最大伤害',
        '+3.64K 故宫合同最大伤害;+55.7秒 直到最大伤害',
        '+17.80K 故宫合同最大伤害;+53.5秒 直到最大伤害',
        '+118.00K 故宫合同最大伤害;+51.4秒 直到最大伤害',
        '+1.12M 故宫合同最大伤害;+49.3秒 直到最大伤害',
        '+16.80M 故宫合同最大伤害;+47.1秒 直到最大伤害',
        '+421.00M 故宫合同最大伤害;+45秒 直到最大伤害',
        '+19.60B 故宫合同最大伤害;+42.8秒 直到最大伤害',
        '+1.92T 故宫合同最大伤害;+40.7秒 直到最大伤害',
        '+458.00T 故宫合同最大伤害;+38.6秒 直到最大伤害',
        '+3.15e017 故宫合同最大伤害;+36.4秒 直到最大伤害',
        '+7.65e020 故宫合同最大伤害;+34.3秒 直到最大伤害',
        '+8.41e024 故宫合同最大伤害;+32.1秒 直到最大伤害',
        '+5.59e029 故宫合同最大伤害;+30秒 直到最大伤害',
      ],
    },
    {
      id: 'blue42',
      name: '幻影控制',
      type: 'Sorcerer',
      icon: 'blue42.png',
      tier: 4,
      column: 2,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 每层多重施法伤害;+1 多重施法次数',
        '×1.62 每层多重施法伤害;+1 多重施法次数',
        '×2.14 每层多重施法伤害;+1 多重施法次数',
        '×3.04 每层多重施法伤害;+1 多重施法次数',
        '×4.63 每层多重施法伤害;+1 多重施法次数',
        '×7.76 每层多重施法伤害;+2 多重施法次数',
        '×14.6 每层多重施法伤害;+2 多重施法次数',
        '×31.7 每层多重施法伤害;+2 多重施法次数',
        '×80.1 每层多重施法伤害;+2 多重施法次数',
        '×245 每层多重施法伤害;+2 多重施法次数',
        '×960 每层多重施法伤害;+3 多重施法次数',
        '×5.08K 每层多重施法伤害;+3 多重施法次数',
        '×38.90K 每层多重施法伤害;+3 多重施法次数',
        '×475.00K 每层多重施法伤害;+3 多重施法次数',
        '×10.60M 每层多重施法伤害;+3 多重施法次数',
      ],
    },
    {
      id: 'green11',
      name: '盗圣',
      type: 'Rogue',
      icon: 'green11.png',
      tier: 1,
      column: 0,
      need: 0,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.6 全部金币;×1.2 后台金币',
        '×2.55 全部金币;×1.38 后台金币',
        '×4.06 全部金币;×1.58 后台金币',
        '×7.13 全部金币;×1.94 后台金币',
        '×12.5 全部金币;×2.38 后台金币',
        '×22 全部金币;×2.92 后台金币',
        '×42.5 全部金币;×3.81 后台金币',
        '×90.2 全部金币;×5.29 后台金币',
        '×191 全部金币;×7.35 后台金币',
        '×445 全部金币;×10.8 后台金币',
        '×1.12K 全部金币;×16.9 后台金币',
        '×3.14K 全部金币;×27.8 后台金币',
        '×9.49K 全部金币;×48.4 后台金币',
        '×34.00K 全部金币;×93.3 后台金币',
        '×132.00K 全部金币;×189 后台金币',
        '×605.00K 全部金币;×421 后台金币',
        '×3.24M 全部金币;×1.03K 后台金币',
        '×21.90M 全部金币;×2.84K 后台金币',
        '×185.00M 全部金币;×8.83K 后台金币',
        '×1.94B 全部金币;×30.80K 后台金币',
        '×24.40B 全部金币;×119.00K 后台金币',
        '×470.00B 全部金币;×541.00K 后台金币',
        '×12.30T 全部金币;×2.86M 后台金币',
        '×450.00T 全部金币;×17.30M 后台金币',
        '×2.63e016 全部金币;×125.00M 后台金币',
      ],
    },
    {
      id: 'green21',
      name: '刺杀',
      type: 'Rogue',
      icon: 'green21.png',
      tier: 2,
      column: 1,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×1.6 致命攻击伤害;+2秒 致命攻击持续时间',
        '×2.52 致命攻击伤害;+5秒 致命攻击持续时间',
        '×3.97 致命攻击伤害;+9秒 致命攻击持续时间',
        '×7.11 致命攻击伤害;+13秒 致命攻击持续时间',
        '×12.8 致命攻击伤害;+18秒 致命攻击持续时间',
        '×22.9 致命攻击伤害;+24秒 致命攻击持续时间',
        '×46.6 致命攻击伤害;+33秒 致命攻击持续时间',
        '×107 致命攻击伤害;+41秒 致命攻击持续时间',
        '×248 致命攻击伤害;+53秒 致命攻击持续时间',
        '×644 致命攻击伤害;+66秒 致命攻击持续时间',
        '×1.89K 致命攻击伤害;+83秒 致命攻击持续时间',
        '×6.21K 致命攻击伤害;+102秒 致命攻击持续时间',
        '×22.90K 致命攻击伤害;+127秒 致命攻击持续时间',
        '×106.00K 致命攻击伤害;+155秒 致命攻击持续时间',
        '×546.00K 致命攻击伤害;+190秒 致命攻击持续时间',
        '×3.48M 致命攻击伤害;+231秒 致命攻击持续时间',
        '×27.40M 致命攻击伤害;+283秒 致命攻击持续时间',
        '×293.00M 致命攻击伤害;+347秒 致命攻击持续时间',
        '×4.23B 致命攻击伤害;+422秒 致命攻击持续时间',
        '×81.50B 致命攻击伤害;+510秒 致命攻击持续时间',
        '×2.10T 致命攻击伤害;+620秒 致命攻击持续时间',
        '×86.00T 致命攻击伤害;+752秒 致命攻击持续时间',
        '×5.60e015 致命攻击伤害;+908秒 致命攻击持续时间',
        '×5.73e017 致命攻击伤害;+1.10K秒 致命攻击持续时间',
        '×1.10e020 致命攻击伤害;+1.32K秒 致命攻击持续时间',
      ],
    },
    {
      id: 'green22',
      name: '召唤匕首',
      type: 'Rogue',
      icon: 'green22.png',
      tier: 2,
      column: 2,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50, 57, 66, 76, 87, 100,
      ],
      effects: [
        '×1.6 匕首伤害; +1 匕首飞溅计数',
        '×2.41 匕首伤害; +2 匕首飞溅计数',
        '×3.63 匕首伤害; +3 匕首飞溅计数',
        '×6.09 匕首伤害; +4 匕首飞溅计数',
        '×10.2 匕首伤害; +5 匕首飞溅计数',
        '×17.2 匕首伤害; +6 匕首飞溅计数',
        '×32.1 匕首伤害; +7 匕首飞溅计数',
        '×66.6 匕首伤害; +8 匕首飞溅计数',
        '×138 匕首伤害; +9 匕首飞溅计数',
        '×317 匕首伤害; +10 匕首飞溅计数',
        '×805 匕首伤害; +11 匕首飞溅计数',
        '×2.25K 匕首伤害; +12 匕首飞溅计数',
        '×6.95K 匕首伤害; +13 匕首飞溅计数',
        '×25.90K 匕首伤害; +14 匕首飞溅计数',
        '×106.00K 匕首伤害; +15 匕首飞溅计数',
        '×516.00K 匕首伤害; +16 匕首飞溅计数',
        '×3M 匕首伤害; +17 匕首飞溅计数',
        '×22.50M 匕首伤害; +18 匕首飞溅计数',
        '×217.00M 匕首伤害; +19 匕首飞溅计数',
        '×2.66B 匕首伤害; +20 匕首飞溅计数',
        '×41.20B 匕首伤害; +21 匕首飞溅计数',
        '×936.00B 匕首伤害; +22 匕首飞溅计数',
        '×30.90T 匕首伤害; +23 匕首飞溅计数',
        '×1.46e015 匕首伤害; +24 匕首飞溅计数',
        '×1.14e017 匕首伤害; +25 匕首飞溅计数',
        '×1.46e019 匕首伤害; +26 匕首飞溅计数',
        '×3.46e021 匕首伤害; +27 匕首飞溅计数',
        '×1.62e024 匕首伤害; +28 匕首飞溅计数',
        '×1.60e027 匕首伤害; +29 匕首飞溅计数',
        '×3.78e030 匕首伤害; +30 匕首飞溅计数',
      ],
    },
    {
      id: 'green23',
      name: '伏击',
      type: 'Rogue',
      icon: 'green23.png',
      tier: 2,
      column: 3,
      need: 3,
      costs: [
        1, 2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28,
        33, 38, 43, 50,
      ],
      effects: [
        '×2多重泰坦金币; +1 最大多重泰坦数量',
        '×3.01多重泰坦金币; +2 最大多重泰坦数量',
        '×5.23多重泰坦金币; +4 最大多重泰坦数量',
        '×9.08多重泰坦金币; +6 最大多重泰坦数量',
        '×18.1多重泰坦金币; +8 最大多重泰坦数量',
        '×36多重泰坦金币; +10 最大多重泰坦数量',
        '×71.8多重泰坦金币; +12 最大多重泰坦数量',
        '×163多重泰坦金币; +14 最大多重泰坦数量',
        '×424多重泰坦金币; +16 最大多重泰坦数量',
        '×1.10K多重泰坦金币; +20 最大多重泰坦数量',
        '×3.23K多重泰坦金币; +20 最大多重泰坦数量',
        '×10.70K多重泰坦金币; +20 最大多重泰坦数量',
        '×40.19K多重泰坦金币; +20 最大多重泰坦数量',
        '×169.00K多重泰坦金币; +20 最大多重泰坦数量',
        '×894.00K多重泰坦金币; +20 最大多重泰坦数量',
        '×5.26M多重泰坦金币; +20 最大多重泰坦数量',
        '×38.50M多重泰坦金币; +20 最大多重泰坦数量',
        '×347.00M多重泰坦金币; +20 最大多重泰坦数量',
        '×4.21B多重泰坦金币; +20 最大多重泰坦数量',
        '×68.20B多重泰坦金币; +20 最大多重泰坦数量',
        '×1.46T多重泰坦金币; +20 最大多重泰坦数量',
        '×41.00T多重泰坦金币; +20 最大多重泰坦数量',
        '×1.78e015多重泰坦金币; +20 最大多重泰坦数量',
        '×1.18e017多重泰坦金币; +20 最大多重泰坦数量',
        '×1.17e019多重泰坦金币; +20 最大多重泰坦数量',
      ],
    },
    {
      id: 'green31',
      name: '突发的运气',
      type: 'Rogue',
      icon: 'green31.png',
      tier: 3,
      column: 1,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '×1 同伴致命一击伤害;+3% 1000X黄金机会',
        '×1.27 同伴致命一击伤害;+3.5% 1000X黄金机会',
        '×1.69 同伴致命一击伤害;+4% 1000X黄金机会',
        '×2.26 同伴致命一击伤害;+4.5% 1000X黄金机会',
        '×3.02 同伴致命一击伤害;+5% 1000X黄金机会',
        '×4.25 同伴致命一击伤害;+5.5% 1000X黄金机会',
        '×6.3 同伴致命一击伤害;+6% 1000X黄金机会',
        '×9.33 同伴致命一击伤害;+6.5% 1000X黄金机会',
        '×14.5 同伴致命一击伤害;+7% 1000X黄金机会',
        '×23.7 同伴致命一击伤害;+7.5% 1000X黄金机会',
        '×40.5 同伴致命一击伤害;+8% 1000X黄金机会',
        '×72.6 同伴致命一击伤害;+8.5% 1000X黄金机会',
        '×142 同伴致命一击伤害;+9% 1000X黄金机会',
        '×291 同伴致命一击伤害;+9.5% 1000X黄金机会',
        '×646 同伴致命一击伤害;+10% 1000X黄金机会',
        '×1.55K 同伴致命一击伤害;+10.5% 1000X黄金机会',
        '×4.19K 同伴致命一击伤害;+11% 1000X黄金机会',
        '×12.60K 同伴致命一击伤害;+11.5% 1000X黄金机会',
        '×42.00K 同伴致命一击伤害;+12% 1000X黄金机会',
        '×150.00K 同伴致命一击伤害;+12.5% 1000X黄金机会',
        '×660.00K 同伴致命一击伤害;+13% 1000X黄金机会',
        '×3.25M 同伴致命一击伤害;+13.5% 1000X黄金机会',
        '×18.3M 同伴致命一击伤害;+14% 1000X黄金机会',
        '×123M 同伴致命一击伤害;+14.5% 1000X黄金机会',
        '×960M 同伴致命一击伤害;+15% 1000X黄金机会',
      ],
    },
    {
      id: 'green32',
      name: '中毒刀片',
      type: 'Rogue',
      icon: 'green32.png',
      tier: 3,
      column: 2,
      need: 20,
      costs: [
        2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14, 16, 19, 22, 25, 28, 33,
        38, 43, 50, 57,
      ],
      effects: [
        '+150% 匕首毒药升压;+1 匕首计数',
        '+247% 匕首毒药升压;+1 匕首计数',
        '+457% 匕首毒药升压;+1 匕首计数',
        '+844% 匕首毒药升压;+2 匕首计数',
        '+1.56K% 匕首毒药升压;+2 匕首计数',
        '+3.22K% 匕首毒药升压;+2 匕首计数',
        '+7.40K% 匕首毒药升压;+3 匕首计数',
        '+17K% 匕首毒药升压;+3 匕首计数',
        '+43.5% 匕首毒药升压;+3 匕首计数',
        '+123K% 匕首毒药升压;+3 匕首计数',
        '+385K% 匕首毒药升压;+4 匕首计数',
        '+1.33M% 匕首毒药升压;+4 匕首计数',
        '+5.57M% 匕首毒药升压;+4 匕首计数',
        '+25.6M% 匕首毒药升压;+4 匕首计数',
        '+141M% 匕首毒药升压;+5 匕首计数',
        '+927M% 匕首毒药升压;+5 匕首计数',
        '+7.88B% 匕首毒药升压;+5 匕首计数',
        '+85.9B% 匕首毒药升压;+5 匕首计数',
        '+1.19T% 匕首毒药升压;+5 匕首计数',
        '+20.8T% 匕首毒药升压;+6 匕首计数',
        '+532T% 匕首毒药升压;+6 匕首计数',
        '+1.96e016% 匕首毒药升压;+6 匕首计数',
        '+1.03e018% 匕首毒药升压;+6 匕首计数',
        '+8.84e019% 匕首毒药升压;+6 匕首计数',
        '+1.22e022% 匕首毒药升压;+7 匕首计数',
      ],
    },
    {
      id: 'green33',
      name: '幽暗奇袭',
      type: 'Rogue',
      icon: 'green33.png',
      tier: 3,
      column: 3,
      need: 20,
      costs: [2, 2, 3, 3, 3, 4, 5, 5, 6, 7, 8, 9, 11, 12, 14],
      effects: [
        '+10% 隐形跳过机会;+15% 隐形阶段',
        '+12.9% 隐形跳过机会;+16.8% 隐形阶段',
        '+15.7% 隐形跳过机会;+18.6% 隐形阶段',
        '+18.6% 隐形跳过机会;+20.4% 隐形阶段',
        '+21.4% 隐形跳过机会;+22.1% 隐形阶段',
        '+24.3% 隐形跳过机会;+23.9% 隐形阶段',
        '+27.1% 隐形跳过机会;+25.7% 隐形阶段',
        '+30% 隐形跳过机会;+27.5% 隐形阶段',
        '+32.9% 隐形跳过机会;+29.3% 隐形阶段',
        '+35.7% 隐形跳过机会;+31.1% 隐形阶段',
        '+38.6% 隐形跳过机会;+32.9% 隐形阶段',
        '+41.4% 隐形跳过机会;+34.6% 隐形阶段',
        '+44.3% 隐形跳过机会;+36.4% 隐形阶段',
        '+47.1% 隐形跳过机会;+38.2% 隐形阶段',
        '+50% 隐形跳过机会;+40% 隐形阶段',
      ],
    },
    {
      id: 'green42',
      name: '匕首风暴',
      type: 'Rogue',
      icon: 'green42.png',
      tier: 4,
      column: 2,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '×1.27 致命一击多重施法伤害;+1 多重施法次数;-1秒 匕首冷却',
        '×1.62 致命一击多重施法伤害;+1 多重施法次数;-2秒 匕首冷却',
        '×2.14 致命一击多重施法伤害;+1 多重施法次数;-3秒 匕首冷却',
        '×3.04 致命一击多重施法伤害;+1 多重施法次数;-4秒 匕首冷却',
        '×4.63 致命一击多重施法伤害;+1 多重施法次数;-5秒 匕首冷却',
        '×7.76 致命一击多重施法伤害;+2 多重施法次数;-6秒 匕首冷却',
        '×14.6 致命一击多重施法伤害;+2 多重施法次数;-7秒 匕首冷却',
        '×31.7 致命一击多重施法伤害;+2 多重施法次数;-8秒 匕首冷却',
        '×80.1 致命一击多重施法伤害;+2 多重施法次数;-9秒 匕首冷却',
        '×245 致命一击多重施法伤害;+2 多重施法次数;-10秒 匕首冷却',
        '×960 致命一击多重施法伤害;+3 多重施法次数;-11秒 匕首冷却',
        '×5.08K 致命一击多重施法伤害;+3 多重施法次数;-12秒 匕首冷却',
        '×38.90K 致命一击多重施法伤害;+3 多重施法次数;-13秒 匕首冷却',
        '×475.00K 致命一击多重施法伤害;+3 多重施法次数;-14秒 匕首冷却',
        '×10.60M 致命一击多重施法伤害;+3 多重施法次数;-15秒 匕首冷却',
      ],
    },
    {
      id: 'green43',
      name: '狙杀瞄准',
      type: 'Rogue',
      icon: 'green43.png',
      tier: 4,
      column: 3,
      need: 50,
      costs: [3, 4, 5, 7, 9, 12, 16, 21, 27, 35, 46, 60, 78, 101, 131],
      effects: [
        '+125% 造成致命一击升压;+2 提升最大计数',
        '+218% 造成致命一击升压;+2 提升最大计数',
        '+413% 造成致命一击升压;+2 提升最大计数',
        '+616% 造成致命一击升压;+3 提升最大计数',
        '+1.61K% 造成致命一击升压;+3 提升最大计数',
        '+5.32K% 造成致命一击升压;+3 提升最大计数',
        '+17.6K% 造成致命一击升压;+4 提升最大计数',
        '+109K% 造成致命一击升压;+4 提升最大计数',
        '+1.02M% 造成致命一击升压;+4 提升最大计数',
        '+12.8M% 造成致命一击升压;+5 提升最大计数',
        '+408M% 造成致命一击升压;+5 提升最大计数',
        '+26.4B% 造成致命一击升压;+6 提升最大计数',
        '+6.50T% 造成致命一击升压;+6 提升最大计数',
        '+6.16e015% 造成致命一击升压;+7 提升最大计数',
        '+5.07e019% 造成致命一击升压;+7 提升最大计数',
      ],
    },
  ],
  crit_reductions: {
    cs: 0.5,
    sc: 1.5,
    hs: 0,
    hscs: 0,
    hssc: 0,
    pet: 1,
  },
  gold_hom_adj: 0.32000000000000006,
  warcry_effects: {
    0: 1,
    1: 2,
    2: 2.1,
    3: 2.3,
    4: 2.5,
    5: 2.8,
    6: 3.1,
    7: 3.5,
    8: 3.9,
    9: 4.4,
    10: 4.9,
    11: 5.4,
    12: 6,
    13: 6.6,
    14: 7.3,
    15: 8,
    16: 8.7,
    17: 9.5,
    18: 10.3,
    19: 11.1,
    20: 12,
    21: 12,
    22: 12,
    23: 12,
    24: 12,
    25: 12,
  },
  clone_effects: {
    0: 0,
    1: 1,
    2: 1.9,
    3: 3.3,
    4: 5.2,
    5: 7.3,
    6: 9.7,
    7: 12.3,
    8: 15.1,
    9: 18.1,
    10: 21.2,
    11: 24.6,
    12: 28,
    13: 31.6,
    14: 35.4,
    15: 39.2,
    16: 43.2,
    17: 47.3,
    18: 51.5,
    19: 55.9,
    20: 60.3,
    21: 64.8,
    22: 69.5,
    23: 74.2,
    24: 79,
    25: 84,
  },
  heroes: [
    { en: 'maya', cn: '守望者玛雅·穆塔', faction: 'spell', type: 'ground' },
    { en: 'zato', cn: '盲棍大师扎托', faction: 'melee', type: 'ground' },
    { en: 'sophia', cn: '剑之勇士索菲亚', faction: 'melee', type: 'ground' },
    { en: 'lance', cn: '钴钢骑士兰斯', faction: 'melee', type: 'ground' },
    { en: 'pingo', cn: '托利族的平哥', faction: 'ranged', type: 'ground' },
    {
      en: 'rosabella',
      cn: '弓箭手罗莎贝拉·邦妮',
      faction: 'ranged',
      type: 'ground',
    },
    { en: 'gulbrand', cn: '毁灭者布尔兰德', faction: 'melee', type: 'ground' },
    { en: 'davey', cn: '戴维·加农船长', faction: 'ranged', type: 'ground' },
    { en: 'rhys', cn: '伊维塔教团法师里斯', faction: 'melee', type: 'ground' },
    { en: 'kronus', cn: '审判使者克洛诺斯', faction: 'spell', type: 'ground' },
    {
      en: 'cosette',
      cn: '佩剑家族之宝柯赛特',
      faction: 'melee',
      type: 'ground',
    },
    { en: 'kiki', cn: '龙骑士琪琪', faction: 'spell', type: 'ground' },
    { en: 'maddie', cn: '影子盗贼玛迪', faction: 'ranged', type: 'ground' },
    { en: 'beany', cn: '豆芽一世', faction: 'spell', type: 'ground' },
    { en: 'sawyer', cn: '荒野枪手索耶', faction: 'ranged', type: 'ground' },
    { en: 'ursa', cn: '小熊乌尔沙', faction: 'spell', type: 'ground' },
    { en: 'saje', cn: '花园守护者萨杰', faction: 'ranged', type: 'ground' },
    { en: 'wally', cn: '魔法师瓦利瓦', faction: 'spell', type: 'ground' },
    { en: 'jayce', cn: '冷血屠夫杰斯', faction: 'melee', type: 'ground' },
    { en: 'pharaoh', cn: '大法老', faction: 'spell', type: 'ground' },
    { en: 'boomoh', cn: '布莫医生', faction: 'melee', type: 'ground' },
    { en: 'dex', cn: 'Dex-1000', faction: 'ranged', type: 'ground' },
    { en: 'cass', cn: '贵夫人卡斯', faction: 'spell', type: 'ground' },
    { en: 'lala', cn: '快箭手拉拉', faction: 'ranged', type: 'ground' },
    { en: 'aya', cn: '闪电紫罗兰阿雅', faction: 'melee', type: 'ground' },
    { en: 'lucy', cn: '暗夜术士露西女士', faction: 'spell', type: 'ground' },
    { en: 'jazz', cn: '爵士摇滚乐手', faction: 'spell', type: 'ground' },
    { en: 'maple', cn: '秋季卫士阿枫', faction: 'melee', type: 'flying' },
    { en: 'kin', cn: '蓬蓬兽阿金', faction: 'ranged', type: 'flying' },
    { en: 'titania', cn: '仙子公主泰坦尼娅', faction: 'spell', type: 'flying' },
    { en: 'miki', cn: '优雅舞者米琪', faction: 'ranged', type: 'ground' },
    { en: 'mina', cn: '光之女祭司米娜', faction: 'spell', type: 'ground' },
    { en: 'yzafa', cn: '恐怖大盗伊扎法', faction: 'melee', type: 'ground' },
    {
      en: 'zolom',
      cn: '太空猎人佐龙·布拉斯特',
      faction: 'ranged',
      type: 'flying',
    },
    { en: 'finn', cn: '怪异卫兵费恩', faction: 'ranged', type: 'ground' },
    { en: 'nohni', cn: '矛灵诺尼', faction: 'melee', type: 'flying' },
    { en: 'damon', cn: '黑暗达蒙', faction: 'spell', type: 'flying' },
    {
      en: 'split',
      cn: '保持所有类型的英雄均衡发展',
      faction: 'melee, spell, ranged',
      type: 'ground, flying',
    },
  ],
  maxStage: 92000,
};

export default {
  vision,
  db,
};
